// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-22T20:05:48.650Z
// Property: Reserves at Tidewater (ID: 6767906449166342)
// Collections: 34 amenities, 9 floorplans (live), 30 photos, 74 POIs, 10 reviews, 5 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162442",
  "multihub_property_id": "6767906449166342",
  "property_external_id": "30911",
  "property_zillow_url": "https://www.zillow.com/apartments/norfolk-va/reserves-at-tidewater/5XqNDm/",
  "property_apartments_url": "https://www.apartments.com/reserves-at-tidewater-norfolk-va/dg9ps3h/",
  "property_google_business_url": "https://www.google.com/maps/place/Reserves+at+Tidewater+Apartment+Homes/data=!4m2!3m1!1s0x0:0xec15937d5695f1a3?sa=X&ved=2ahUKEwj74rvz4LiSAxWQmSYFHXJGCM0Q_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "54896221110",
  "property_crm_software": "EliseAI",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "reserves-at-tidewater",
  "property_name": "Reserves at Tidewater",
  "property_website_url": "https://www.reservesattidewater.com/",
  "property_domain": "https://www.reservesattidewater.com/",
  "property_address": "8600 Glen Myrtle Avenue",
  "property_full_address": "8600 Glen Myrtle Ave, Norfolk, VA 23505",
  "property_address_1": "8600 Glen Myrtle Ave",
  "property_address_2": null,
  "property_address_city": "Norfolk",
  "property_address_state": "VA",
  "property_address_zip_full": "23505-5402",
  "property_address_zip": "23505",
  "property_address_country": "US",
  "property_address_county": "Norfolk City",
  "property_neighborhood_address": "Glenwood Park",
  "property_address_latitude": "36.9310324",
  "property_address_longitude": "-76.30919020000002",
  "property_email": "reservestidewater@aionmangement.com",
  "property_phone": "(757) 440-0000",
  "property_call_tracking_phone": "888-782-7620",
  "property_company_name": "AION Management ",
  "property_company_url": "https://www.aionmanagement.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Elevate your lifestyle at Reserves at Tidewater in Norfolk, VA! Choose from spacious one- and two-bedroom floor plans, featuring modern kitchens and private balconies. Enjoy amenities like a fitness center, swimming pool, and a dog park. Ready to call this vibrant community home? Browse our availability or schedule a tour today!",
  "property_long_description": "**Discover Your Perfect Apartment at Reserves at Tidewater**\n\nWelcome to the Reserves at Tidewater, where modern living meets comfort and convenience in beautiful Norfolk, VA. Our diverse selection of thoughtfully designed floor plans, including spacious one and two-bedroom apartments, ensures that you'll find the ideal space to suit your lifestyle.\n\nOur community boasts an array of outstanding amenities to elevate your living experience. Enjoy the luxuries of a fully-equipped fitness center, a relaxing swimming pool, and inviting grilling stations perfect for gatherings with friends. Embrace the outdoors at our playground, dog park, and picnic area, all beautifully set within our carefully landscaped grounds featuring stunning pond views.\n\nAt Reserves at Tidewater, we understand the importance of flexibility, which is why we offer flex rent payments and short-term leases to accommodate your needs. Our online resident portal simplifies management tasks while our on-site management team and 24-hour emergency maintenance ensure peace of mind.\n\nYour furry companions are welcome here too, as we are a pet-friendly community. Inside your apartment, you'll find an upgraded kitchen with stainless steel appliances, granite countertops, and ample storage, all complemented by stylish finishes such as vaulted ceilings and hardwood flooring.\n\nRevel in the convenience of on-site parking, garages, and controlled access for security and comfort. Whether you're enjoying a cozy evening by the fireplace or soaking up the sun on your private patio or balcony, your new home at Reserves at Tidewater is waiting for you.\n\nFind your new home today—browse our availability or schedule a tour to experience our vibrant community firsthand!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce07-ed12-74be-811c-59762f227d30.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and trees.",
    "public_id": "019fce07-ed12-74be-811c-59762f227d30",
    "storage_key": "property/6767906449166342/019fce07-ed12-74be-811c-59762f227d30.webp",
    "width": 1920,
    "height": 1282
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "640",
  "property_year_built": "1988",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.9375",
  "property_admin_fee": null,
  "property_application_fee": "50",
  "property_fees_deposit_info": "Security Deposit: $750",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "55",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Maximum 2 pets per apartment, each up to 100 lb.",
  "property_pet_policy_description": "Cats and dogs are welcome. Maximum 2 pets per apartment, each up to 100 lb. A non‑refundable pet fee of $350 and monthly pet rent of $50 per pet are required.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://reservesattidewaternorfolk.loftliving.com/login",
  "property_apply_now_url": "https://www.reservesattidewater.com/apply-now",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026a-485b-75bf-83c9-aa5ba463a446.webp",
  "property_primary_logo_media": {
    "alt_text": "Reserves at Tidewater logo",
    "public_id": "019d026a-485b-75bf-83c9-aa5ba463a446",
    "storage_key": "property/6767906449166342/019d026a-485b-75bf-83c9-aa5ba463a446.webp",
    "width": 167,
    "height": 75
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026d-efca-763e-a82c-b2ff386eeb1d.webp",
  "property_secondary_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d026d-efca-763e-a82c-b2ff386eeb1d",
    "storage_key": "property/6767906449166342/019d026d-efca-763e-a82c-b2ff386eeb1d.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026d-ffa0-7320-8e5b-45765988f163.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Reserves at Tidewater logo",
    "public_id": "019d026d-ffa0-7320-8e5b-45765988f163",
    "storage_key": "property/6767906449166342/019d026d-ffa0-7320-8e5b-45765988f163.webp",
    "width": 167,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026e-09d3-700e-8cc0-f93ab6c98811.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Reserves at Tidewater logo",
    "public_id": "019d026e-09d3-700e-8cc0-f93ab6c98811",
    "storage_key": "property/6767906449166342/019d026e-09d3-700e-8cc0-f93ab6c98811.webp",
    "width": 167,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
  "property_company_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0264-670c-7240-a629-183122c7de9e",
    "storage_key": "company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
    "width": 598,
    "height": 250
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#002142",
  "property_secondary_color": "#494747",
  "property_font_color": "#002142",
  "property_color_4": null,
  "property_color_3": "#f18c20",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "675 - 965",
  "property_sqft_min": "675",
  "property_sqft_max": "965",
  "property_price_range": "1153 - 1839",
  "property_price_min": "1153",
  "property_price_max": "1839",
  "property_available_units": 26,
  "property_facebook_url": "https://www.facebook.com/reservesattidewater/",
  "property_instagram_url": "https://www.instagram.com/reservesattidewater",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJTec_syqauokRo_GVVn2TFew",
  "property_youtube_url": "https://www.youtube.com/watch?v=q37-8CO-xsI",
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartments&find_loc=Norfolk%2C+VA",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Reserves at Tidewater",
  "property_home_romance_title": "Embrace Comfort and Connection in Your New Apartment Home",
  "property_home_amenities_blurb": "Welcome to Reserves at Tidewater in vibrant Norfolk, VA, where modern living meets comfort. Choose between charming one- and two-bedroom floor plans, complete with upgraded kitchens and captivating views. Enjoy top-notch amenities like a fitness center, swimming pool, and a pet-friendly dog park, tailored for your lifestyle.",
  "property_home_floorplans_blurb": "Welcome to Reserves at Tidewater in Norfolk, VA, where comfort meets style. Choose from our thoughtfully designed one and two-bedroom floor plans, crafted for your lifestyle. Dive into a sanctuary that suits your needs and enjoy modern living. Browse our available apartment homes and find your ideal space today!",
  "property_home_gallery_blurb": "At Reserves at Tidewater in Norfolk, VA, spacious living awaits with one and two-bedroom floor plans designed for comfort. Enjoy resort-style amenities including a sparkling pool, dog park, and fitness center. Imagine your vibrant lifestyle enhanced by chic upgrades, from stainless steel appliances to cozy fireplaces—your new home is a breath away!",
  "property_home_neighborhood_blurb": "At Reserves at Tidewater in Norfolk, VA, vibrant living meets convenience. Nestled amid cultural gems like the Chrysler Museum of Art and breathtaking Norfolk Botanical Garden, our one- and two-bedroom apartments offer easy access to local amenities. Dive into a community teeming with charm, schools, parks, and more!",
  "property_home_reviews_blurb": "At Reserves at Tidewater, residents enjoy a welcoming community with helpful staff who truly care. “The front office is really, really nice...they always address any concerns quickly.” With spacious apartments, modern amenities, and a prime Norfolk location near ODU, make this your perfect first home or student retreat!",
  "property_neighborhood_blurb": "At Reserves at Tidewater in Norfolk, VA, your new home is surrounded by an abundance of cultural treasures and vibrant community gems. From the serene Norfolk Botanical Garden to the dynamic attractions of The NorVa and Chrysler Museum of Art, your adventures await just beyond your doorstep. See what’s around our community!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Reserves at Tidewater in Norfolk, VA, modern living meets unparalleled comfort. Choose from spacious one or two-bedroom floor plans featuring sleek stainless steel appliances, vaulted ceilings, and private patios. Enjoy our vibrant clubhouse, fitness center, and dog park while experiencing the convenience of flex rent payments and 24-hour maintenance.",
  "property_applynow_blurb": "At Reserves at Tidewater in Norfolk, VA, stylish one and two-bedroom apartments await. Enjoy modern amenities like a fitness center, swimming pool, and dog park, all while relishing the comfort of flexible rent payments and 24-hour maintenance. Your new home is just a click away—lease online today!",
  "property_contactus_blurb": "At Reserves at Tidewater in Norfolk, VA, we offer thoughtfully designed one and two-bedroom floor plans to suit your lifestyle. Whether you seek cozy elegance or spacious comfort, our community has the perfect home for you. Have questions? Contact our leasing team today for personalized assistance!",
  "property_faqs_blurb": "At Reserves at Tidewater in Norfolk, VA, our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle, offering comfort and convenience. Have questions? Visit our FAQs page for insightful answers about living in our vibrant community, ensuring you feel right at home from day one.",
  "property_floorplans_blurb": "At Reserves at Tidewater in Norfolk, VA, elegance meets comfort in every corner. Choose from our thoughtfully designed one and two-bedroom floor plans, crafted to suit your lifestyle. Browse our available apartment homes today and envision your new sanctuary by the water. Your ideal living space awaits!",
  "property_gallery_blurb": "At Reserves at Tidewater in Norfolk, VA, picture picturesque pond views and vaulted ceilings as you relax on your private balcony. Enjoy pet-friendly amenities like a dog park, clubhouse gatherings, and sun-soaked afternoons by the sparkling pool. Each home boasts modern finishes—experience the perfect blend of comfort and community!",
  "property_interactivemap_blurb": "Welcome to the Reserves at Tidewater in vibrant Norfolk, VA. Our versatile one- and two-bedroom apartments feature modern amenities and serene pond views. With flexible rent payments, a pet-friendly environment, and an array of recreational options, your ideal home awaits. Use our interactive community map to find your perfect space!",
  "property_pets_blurb": "At Reserves at Tidewater in Norfolk, VA, your furry friends are family! Enjoy spacious living with your pets, where the charm of our community meets the freedom to roam. With a maximum of two pets per apartment, let your four-legged companions thrive in comfort and style.",
  "property_referafriend_blurb": "At Reserves at Tidewater in Norfolk, VA, your next home awaits! With spacious one and two-bedroom floor plans designed for comfort and style, you and your friends can enjoy a vibrant community. Great friends make great neighbors—refer a friend today and elevate your living experience together!",
  "property_residentaccess_blurb": "Welcome to Reserves at Tidewater in vibrant Norfolk, VA, where your ideal living space awaits! Choose from our stylish one or two-bedroom floor plans tailored for comfort. Access your resident portal to seamlessly manage your home—pay rent, schedule maintenance, and enjoy community perks—all at your fingertips!",
  "property_reviews_blurb": "At Reserves at Tidewater, our vibrant community shines through glowing reviews from residents who call it home. With friendly neighbors and attentive staff, many have found their perfect apartment oasis just minutes from ODU and military bases. Experience a welcoming atmosphere that makes every day feel special.",
  "property_created_at": "1757011396972",
  "property_scheduletour_blurb": "At Reserves at Tidewater in Norfolk, VA, our thoughtfully designed one and two-bedroom floor plans offer the perfect blend of comfort and style. Experience community living where every detail is crafted for you. Curious about your future home? See what our residents have to say about their vibrant lifestyle!",
  "property_thankyou_blurb": "Thank you for reaching out to Reserves at Tidewater in Norfolk, VA! Our thoughtfully designed one and two-bedroom apartments offer the perfect blend of comfort and style. A member of our dedicated team will connect with you soon to help you find your ideal home sweet home!",
  "property_virtualtours_blurb": "Step into the vibrant lifestyle at Reserves at Tidewater in Norfolk, VA! With spacious one and two-bedroom floor plans, our community offers the perfect blend of comfort and style. Experience your future home from the comfort of your screen—take a virtual tour of our apartments for rent today!",
  "property_copyright": "2025 All Rights Reserved. Reserves at Tidewater",
  "property_seo_title_home": "Reserves at Tidewater |  Apartments in Norfolk, VA",
  "property_seo_description_home": "Experience modern living at Reserves at Tidewater in Norfolk, VA. Enjoy pet-friendly amenities, upgraded kitchens, and flexible leases. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Norfolk, VA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Reserves at Tidewater in Norfolk, VA. Explore stylish one and two-bedroom floor plans and unlock comfort and convenience today!",
  "property_seo_title_amenities": "Amenities | Norfolk, VA Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury living at Reserves at Tidewater in Norfolk, VA. Enjoy upgraded kitchens, a fitness center, dog park, and more. Your ideal lifestyle awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Norfolk, VA",
  "property_seo_description_gallery": "Experience life at Reserves at Tidewater in Norfolk, VA. Stylish apartments, top-notch amenities, and inviting spaces await. Picture your new home today!",
  "property_seo_title_virtualtours": "Virtual Tours | Reserves at Tidewater Apartments",
  "property_seo_description_virtualtours": "Step into the comforts of Reserves at Tidewater in Norfolk, VA! Take a virtual tour and envision your future in our spacious one & two-bedroom homes.",
  "property_seo_title_interactivemap": "Interactive Map | Reserves at Tidewater Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Reserves at Tidewater, Norfolk, VA! Explore interactive floor plans, amenities, and lively community living.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Norfolk, VA",
  "property_seo_description_neighborhood": "Uncover the vibrant neighborhood surrounding Reserves at Tidewater in Norfolk, VA. Dive into local favorites and hidden gems just steps from your new home!",
  "property_seo_title_contact": "Contact Us | Reserves at Tidewater",
  "property_seo_description_contact": "Connect with the Reserves at Tidewater in Norfolk, VA! Inquire about our stunning one and two-bedroom floor plans. Your new home awaits—reach out now!",
  "property_seo_title_faqs": "FAQs | Apartments in Norfolk, VA",
  "property_seo_description_faqs": "Find answers about Reserves at Tidewater in Norfolk, VA! Check our FAQs for info on amenities, floor plans, and community life.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Norfolk, VA",
  "property_seo_description_reviews": "Join our vibrant community at Reserves at Tidewater in Norfolk, VA. Read resident reviews and see why they love their stylish homes and top-tier amenities!",
  "property_seo_title_applynow": "Apply Now | Apartments in Norfolk, VA",
  "property_seo_description_applynow": "Find your perfect sanctuary at Reserves at Tidewater in Norfolk, VA! Enjoy modern living with top-notch amenities, flexible leasing, and pet-friendly spaces.",
  "property_seo_title_residentaccess": "Resident Access | Reserves at Tidewater",
  "property_seo_description_residentaccess": "Access your resident portal at Reserves at Tidewater in Norfolk, VA—manage rent, request maintenance, and stay connected to your community effortlessly!",
  "property_seo_title_referafriend": "Refer A Friend | Reserves at Tidewater",
  "property_seo_description_referafriend": "Great friends make amazing neighbors! Refer a friend to Reserves at Tidewater in Norfolk, VA, and enjoy a vibrant community together. Share the joy today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Reserves at Tidewater",
  "property_seo_description_scheduletour": "Experience coastal living at Reserves at Tidewater in Norfolk, VA. Schedule a tour today and find your perfect home by the water's edge!",
  "property_seo_title_privacy": "Privacy Policy | Reserves at Tidewater",
  "property_seo_description_privacy": "Your privacy is our priority at Reserves at Tidewater. Dive into our policy to see how we protect your information in beautiful Norfolk, VA.",
  "property_seo_title_accessibility": "Website Accessibility | Reserves at Tidewater",
  "property_seo_description_accessibility": "At Reserves at Tidewater in Norfolk, VA, we prioritize digital inclusivity. Our accessibility statement ensures everyone can navigate our community with ease.",
  "property_seo_title_sitemap": "Sitemap | Reserves at Tidewater",
  "property_seo_description_sitemap": "Navigate your way to comfort at Reserves at Tidewater in Norfolk, VA. Check out our sitemap to find your perfect home and enjoy community living like no other!",
  "property_seo_title_thankyou": "Thank You | Reserves at Tidewater",
  "property_seo_description_thankyou": "Thank you for reaching out to Reserves at Tidewater! Our team will connect with you soon to guide you toward your ideal Norfolk home. Stay tuned for updates!",
  "property_seo_title_pets": "Pet Policy | Apartments in Norfolk, VA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293568714",
  "amenities": [
    {
      "id": "custom_522d1bc0-dd12-43f1-80ff-ce07b4bd96a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3bcdbc2a-0a29-481e-a740-57c75ced4d4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_83b65114-e1a7-4a99-82a8-c8dea7e27640",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7f03ee23-6c59-44d7-938a-7f6a8790ff40",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "external_id": "false",
      "title": "Laundry Facility",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6b19f116-109b-4379-8691-4447350cd534",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "external_id": "false",
      "title": "Online Maintenance Requests",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5996532a-5d17-4df9-ab64-e090c22fcb24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rent Payment & Resident Portal",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2377d272-9f64-4bdd-826b-bb52920d2fdf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e2c0ad92-9a66-4095-a972-a9d2115c68f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Management",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_da7791ea-add6-4d8e-99b7-67a852b0bf84",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_38a2eae9-86a7-4744-8cef-531256a6cd3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Lounge",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e8add84c-f7cf-4cc6-93b2-c3e43ae91df8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "external_id": "false",
      "title": "Short-Term Leases",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_695cee75-d970-41b6-ab0b-dc42d10aefd6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_18a80a9e-8204-40d9-91fe-39972b0c5d82",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "external_id": "false",
      "title": "Breakfast Bars*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ada3fcf4-1226-4771-8c13-c5125df8a83e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "external_id": "false",
      "title": "Built-In Microwave*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_65fe8b9b-c741-4b5f-a8fe-4e79447775eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c0fb9f69-a24d-48c3-a43c-29ccabcac0f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fan*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a70d4dec-7bb1-4ca9-8aa8-8d3c624b6f62",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9cb20714-1d31-456c-b76f-3f585e2d81b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "external_id": "false",
      "title": "High-Speed Internet",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_786f8922-804f-45b2-af24-09224bc89be3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "external_id": "false",
      "title": "In-Unit Washer & Dryers*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dbb6f6ba-c650-40de-be18-1b17dba1065e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "external_id": "false",
      "title": "Quartz Countertops*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_82b954db-3f68-485e-ae0d-88b5eb1880ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated Kitchens & Baths*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_90aee3f8-a9a5-411c-bf22-94870540058a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless-Steel Appliances*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fc649b54-5944-456a-b682-271daa49e23e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "external_id": "false",
      "title": "Subway-Style Backsplash*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_476e61e2-1016-45aa-90fa-7069e96080f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "external_id": "false",
      "title": "Upgraded Lighting*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_442f6132-676c-47cb-8003-112fd765e552",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "external_id": "false",
      "title": "Vinyl Hardwood Floors*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f63faf25-e852-43e2-a562-31e391a4b730",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "external_id": "false",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2f141f9f-d9ea-44d1-8499-35fa8cdadad9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "external_id": "false",
      "title": "Window Coverings",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ec3433c5-2ba3-44b8-a83a-a7521dd878e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "external_id": "false",
      "title": "2.5 Miles from Norfolk Naval Station",
      "amount": "false",
      "description": "",
      "group": "Neighborhood",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2f094e19-5cfc-4f19-a9a4-fd8a3de915ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1f701ad2-8d9d-4b46-97fa-806bb982b789",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "external_id": "false",
      "title": "Free Off-Street Parking",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a950b022-4c40-485b-b2e8-b064f338d22c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "external_id": "false",
      "title": "Grilling & Picnic Area",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d1acad4c-d408-4901-9ad8-a7cea54e4105",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8f392c42-b3d1-484e-95db-ce7914a6a5b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "external_id": "false",
      "title": "Reserved Parking Available",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9eed0798-a3b3-4dc5-a183-19e0668ee567",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "external_id": "false",
      "title": "Swimming Pool & Sundeck",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_9d8c8518-dc32-4dad-a4af-e0e7389307bd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce07-fbbd-708d-ac9c-994c29833187.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and subway tile backsplash.",
        "public_id": "019fce07-fbbd-708d-ac9c-994c29833187",
        "storage_key": "property/6767906449166342/019fce07-fbbd-708d-ac9c-994c29833187.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bright and spacious kitchen featuring sleek white cabinetry, durable granite countertops, and a full suite of modern stainless steel appliances for a clean, contemporary look.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, gray countertops, and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/67f352cd/dms3rep/multi/5767906449162442/6767906449166342/355fbb204dd7cabda980132bfb3d8460.jpg"
    },
    {
      "id": "custom_4b9166b7-609b-4855-9482-bb681b50dbf0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce07-fba3-744b-b98f-02e795bd3c04.webp",
      "image_media": {
        "alt_text": "A staged living room with a sofa, coffee table, and tv.",
        "public_id": "019fce07-fba3-744b-b98f-02e795bd3c04",
        "storage_key": "property/6767906449166342/019fce07-fba3-744b-b98f-02e795bd3c04.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Enjoy your downtime in this spacious and well-appointed living room, perfect for relaxing or entertaining guests.",
      "link": "false",
      "alt_text": "Living room with a gray sofa, coffee table, plant, and large window with blinds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/67f352cd/dms3rep/multi/5767906449162442/6767906449166342/d7fdbec940559a82d9a44710fdfe8594.jpg"
    },
    {
      "id": "custom_877f7139-5951-4779-abcd-a6cec1270710",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce07-fbd6-70c5-9fa0-fd9ccdb3152f.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen with white cabinets and granite countertops.",
        "public_id": "019fce07-fbd6-70c5-9fa0-fd9ccdb3152f",
        "storage_key": "property/6767906449166342/019fce07-fbd6-70c5-9fa0-fd9ccdb3152f.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Open-concept apartment kitchen and dining space with white cabinets, a granite counter, and stainless-steel appliances.",
      "link": "false",
      "alt_text": "Open-concept dining area with a wooden table, four chairs, and a modern kitchen with white cabinets and stainless-steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/67f352cd/dms3rep/multi/5767906449162442/6767906449166342/4c568a12602284d59792761449c95bef.jpg"
    },
    {
      "id": "custom_a7051dc4-63fa-4b18-982d-46daa91a81ae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce07-fc19-77da-9c8c-ad2ee5cfd3a4.webp",
      "image_media": {
        "alt_text": "Bedroom with a large white bed, nightstand, dresser, and a large window with grey curtains.",
        "public_id": "019fce07-fc19-77da-9c8c-ad2ee5cfd3a4",
        "storage_key": "property/6767906449166342/019fce07-fc19-77da-9c8c-ad2ee5cfd3a4.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed, modern decor, and ample natural light from a large window.",
      "link": "false",
      "alt_text": "Modern apartment bedroom with white bedding, gray walls, large window with curtains, and dresser.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/67f352cd/dms3rep/multi/5767906449162442/6767906449166342/9f65815c34c0f3e57b0e606c44f9f899.jpg"
    },
    {
      "id": "custom_1edcfc03-508b-400f-a38f-c5f983b5eb37",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-06e6-7248-b608-03d4395b983f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019fce08-06e6-7248-b608-03d4395b983f",
        "storage_key": "property/6767906449166342/019fce08-06e6-7248-b608-03d4395b983f.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bright, contemporary apartment kitchen with white cabinetry, granite counters, and an open dining nook.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a small dining area in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/67f352cd/dms3rep/multi/5767906449162442/6767906449166342/9dfbee122488ec0a08dc911f34881a77.jpg"
    },
    {
      "id": "custom_c9c0033f-4adb-494f-82a8-faa5f92628b8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-0705-772f-8e0c-112eddcb44e6.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry.",
        "public_id": "019fce08-0705-772f-8e0c-112eddcb44e6",
        "storage_key": "property/6767906449166342/019fce08-0705-772f-8e0c-112eddcb44e6.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen with white shaker cabinets, granite countertops, subway tile backsplash, and stainless steel appliances.",
      "link": "false",
      "alt_text": "Kitchen in an apartment with white cabinets, granite countertops, and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/67f352cd/dms3rep/multi/5767906449162442/6767906449166342/72d1190ffaa6bdc29fb36f5e222962ff.jpg"
    },
    {
      "id": "custom_9d0939a2-a0aa-45a0-8bec-b49be91494de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-06f0-73ad-9677-2813df92cd0f.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, armchair, and dining area visible through a pass-through.",
        "public_id": "019fce08-06f0-73ad-9677-2813df92cd0f",
        "storage_key": "property/6767906449166342/019fce08-06f0-73ad-9677-2813df92cd0f.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Modern apartment living area with neutral tones, contemporary furniture, and an open kitchen pass-through.",
      "link": "false",
      "alt_text": "Open-concept living room with gray walls, a sofa, chairs, and a sightline to the kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/67f352cd/dms3rep/multi/5767906449162442/6767906449166342/8a3e5bc55fee9d9be1298fb32e79275a.jpg"
    },
    {
      "id": "custom_da47be76-cf59-4c1e-ab72-bfd63a2cbe6b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-0705-772f-8e0c-15a7aa857a61.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, and a window.",
        "public_id": "019fce08-0705-772f-8e0c-15a7aa857a61",
        "storage_key": "property/6767906449166342/019fce08-0705-772f-8e0c-15a7aa857a61.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Modern apartment living room with neutral tones, natural light from a large window, and minimalist décor.",
      "link": "false",
      "alt_text": "Bright living room with gray walls, window blinds, sofa, coffee table, and potted plants.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/67f352cd/dms3rep/multi/5767906449162442/6767906449166342/ed3af64ef28532c3bb035517e302eb29.jpg"
    },
    {
      "id": "custom_8bb0a1ab-7c98-446e-870c-20791a34b650",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-115f-7209-8159-a083c2490838.webp",
      "image_media": {
        "alt_text": "Bedroom with a large white bed, a dresser with a TV, and a ladder shelf.",
        "public_id": "019fce08-115f-7209-8159-a083c2490838",
        "storage_key": "property/6767906449166342/019fce08-115f-7209-8159-a083c2490838.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Cozy modern bedroom in a multifamily property with a large bed, white dresser, wall TV, and minimalist bookshelf.",
      "link": "false",
      "alt_text": "Bedroom interior with a large bed, white dresser, wall TV, bookshelf, and two doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/67f352cd/dms3rep/multi/5767906449162442/6767906449166342/f192a8718e3ef4804d46743eb3d3fbdc.jpg"
    },
    {
      "id": "custom_8d164234-8be3-43c4-b1ca-63485351fe73",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-130d-71dd-a30d-654c90456e77.webp",
      "image_media": {
        "alt_text": "Modern home office setup with a sleek desk, computer, keyboard, and decorative shelving.",
        "public_id": "019fce08-130d-71dd-a30d-654c90456e77",
        "storage_key": "property/6767906449166342/019fce08-130d-71dd-a30d-654c90456e77.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bright apartment interior with a desk, monitor, and decorative shelving in a modern home office.",
      "link": "false",
      "alt_text": "Home office setup with a wooden desk, monitor, and gray shelving in a light-gray apartment room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/67f352cd/dms3rep/multi/5767906449162442/6767906449166342/3055dac5c5af3c819557877c9dce2363.jpg"
    },
    {
      "id": "custom_133316de-1fa7-43d9-87ec-d09438773948",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-1475-7348-a346-aa338d3eccd4.webp",
      "image_media": {
        "alt_text": "Living room and dining area in an apartment.",
        "public_id": "019fce08-1475-7348-a346-aa338d3eccd4",
        "storage_key": "property/6767906449166342/019fce08-1475-7348-a346-aa338d3eccd4.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Open-concept living area in a modern apartment featuring a brown sectional, flat-screen TV, and a view into the kitchen.",
      "link": "false",
      "alt_text": "Living room with a brown sectional sofa, flat-screen TV, tall plant, and view into the open kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/67f352cd/dms3rep/multi/5767906449162442/6767906449166342/7f3e0af28f4a01713173abb51f030f75.jpg"
    },
    {
      "id": "custom_0027a46a-2f51-4078-a1fd-ff6e29fae4ab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-1d54-73dc-ab7c-26368dfe6aac.webp",
      "image_media": {
        "alt_text": "Interior view of a living room with a brown couch, butterfly chair, coffee table, and entryway storage.",
        "public_id": "019fce08-1d54-73dc-ab7c-26368dfe6aac",
        "storage_key": "property/6767906449166342/019fce08-1d54-73dc-ab7c-26368dfe6aac.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Interior shot of a modern apartment living area with wood floors, a brown sofa, sling chair, coffee tables, plant, and a coat rack by the window.",
      "link": "false",
      "alt_text": "Living room of an apartment with sofa, sling chair, coffee tables, plant, and coat rack near a window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/67f352cd/dms3rep/multi/5767906449162442/6767906449166342/c916213d2469531f11761faebae52274.jpg"
    },
    {
      "id": "custom_15679934-0fa2-4417-a92c-4c8928893b74",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-1fe0-728c-aacc-da44da7266b2.webp",
      "image_media": {
        "alt_text": "Dining area with a table and chairs next to a refrigerator and kitchen cabinets.",
        "public_id": "019fce08-1fe0-728c-aacc-da44da7266b2",
        "storage_key": "property/6767906449166342/019fce08-1fe0-728c-aacc-da44da7266b2.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Cozy apartment interior with a dining nook, hardwood floors, and a visible kitchen with a fridge.",
      "link": "false",
      "alt_text": "Dining area with a black table and two chairs adjacent to a small kitchen and refrigerator.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/67f352cd/dms3rep/multi/5767906449162442/6767906449166342/5e7054e098fb92ec1584229dc3e3bff2.jpg"
    },
    {
      "id": "custom_e0b86692-de40-4656-9636-13866319da24",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-2918-7353-aab9-2ce762b7045b.webp",
      "image_media": {
        "alt_text": "Bedroom with bed, dresser, TV, and window.",
        "public_id": "019fce08-2918-7353-aab9-2ce762b7045b",
        "storage_key": "property/6767906449166342/019fce08-2918-7353-aab9-2ce762b7045b.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Cozy apartment bedroom with neutral decor, dresser, TV, and a window for natural light.",
      "link": "false",
      "alt_text": "Bedroom in an apartment with a bed, dresser, wall clock, and a window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/67f352cd/dms3rep/multi/5767906449162442/6767906449166342/73784474e20f213bda2479be73667670.jpg"
    },
    {
      "id": "custom_b949dd0c-e64d-4d31-b5e1-6f7708fb0389",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-33ce-700e-a87e-8ea5b8ff4b73.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, mirror, and towel ring.",
        "public_id": "019fce08-33ce-700e-a87e-8ea5b8ff4b73",
        "storage_key": "property/6767906449166342/019fce08-33ce-700e-a87e-8ea5b8ff4b73.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Modern bathroom vanity with white basin, large mirror, towel ring, and sleek metal hardware.",
      "link": "false",
      "alt_text": "Bathroom vanity with white sink, mirror, towel ring, and brushed metal fixtures.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/67f352cd/dms3rep/multi/5767906449162442/6767906449166342/dbb846c19ac1dd6f9229bee3e1d05739.jpg"
    },
    {
      "id": "custom_d1488b0f-03e7-47e1-9d20-16a4e6b49314",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-355f-7288-a0ec-ec1a32311934.webp",
      "image_media": {
        "alt_text": "Stackable LG washer and dryer in a closet",
        "public_id": "019fce08-355f-7288-a0ec-ec1a32311934",
        "storage_key": "property/6767906449166342/019fce08-355f-7288-a0ec-ec1a32311934.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Compact apartment laundry closet featuring a stacked front-loading washer and dryer.",
      "link": "false",
      "alt_text": "In-unit laundry closet with a stacked washer and dryer behind an open door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/67f352cd/dms3rep/multi/5767906449162442/6767906449166342/24719221e80f8035da1cad16c179eef5.jpg"
    },
    {
      "id": "custom_66777d26-a436-4a65-a25b-789cac0defa4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-3db3-7554-8a3a-a0bff50619fa.webp",
      "image_media": {
        "alt_text": "Kitchen with stove and refrigerator",
        "public_id": "019fce08-3db3-7554-8a3a-a0bff50619fa",
        "storage_key": "property/6767906449166342/019fce08-3db3-7554-8a3a-a0bff50619fa.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Compact apartment kitchen with a stove, refrigerator, and wood-toned cabinets.",
      "link": "false",
      "alt_text": "Compact apartment kitchen with a white stove, cabinets, and a fridge.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/67f352cd/dms3rep/multi/5767906449162442/6767906449166342/0a13f6894611043f47757880f3a1fb28.jpg"
    },
    {
      "id": "custom_d58de066-01fc-4630-a010-72f71d7eaf88",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-40ff-72fa-b271-e7fd291b27be.webp",
      "image_media": {
        "alt_text": "Kitchen with wood cabinets, stainless steel sink, and countertop. A fruit bowl sits on the counter.",
        "public_id": "019fce08-40ff-72fa-b271-e7fd291b27be",
        "storage_key": "property/6767906449166342/019fce08-40ff-72fa-b271-e7fd291b27be.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bright apartment kitchen with wood cabinets, beige countertops, a stainless sink, and open sightlines to the living area.",
      "link": "false",
      "alt_text": "Kitchen with oak cabinets, beige countertops, a stainless sink, and wood flooring.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/67f352cd/dms3rep/multi/5767906449162442/6767906449166342/904f6b26ad064accf8d94fb44fd605c4.jpg"
    },
    {
      "id": "custom_94521dd0-9b9e-48cf-9227-e362744088fe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-4902-72a5-9c1c-37cd2b0ccce9.webp",
      "image_media": {
        "alt_text": "Playground with blue slide and swings in front of brick buildings.",
        "public_id": "019fce08-4902-72a5-9c1c-37cd2b0ccce9",
        "storage_key": "property/6767906449166342/019fce08-4902-72a5-9c1c-37cd2b0ccce9.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Colorful community playground at a multifamily property featuring a tall blue slide and purple play equipment.",
      "link": "false",
      "alt_text": "Bright playground with a long blue tube slide and purple climbing structures in a residential yard.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/67f352cd/dms3rep/multi/5767906449162442/6767906449166342/d70aa104dbefc9dd15ae8bbaacb2ab14.jpg"
    },
    {
      "id": "custom_eafdda0f-873d-4bd3-964f-2dd76b1e2eae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-48ac-77bd-bece-bc8ba331b508.webp",
      "image_media": {
        "alt_text": "Spacious living area with a large sectional sofa, fireplace, and modern kitchen.",
        "public_id": "019fce08-48ac-77bd-bece-bc8ba331b508",
        "storage_key": "property/6767906449166342/019fce08-48ac-77bd-bece-bc8ba331b508.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Bright, modern apartment living room with a blue accent wall, fireplace, mounted TV, and open kitchen.",
      "link": "false",
      "alt_text": "Modern living room in a multifamily unit with a gray sectional, blue accent wall, fireplace, and open kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/67f352cd/dms3rep/multi/5767906449162442/6767906449166342/abcaa9b0fce911618605a58e01ceb482.jpg"
    },
    {
      "id": "custom_9a0c65e2-cf7d-4a8b-8e33-e01b8afc9afe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-4c49-7252-89ac-296366e54629.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and trees.",
        "public_id": "019fce08-4c49-7252-89ac-296366e54629",
        "storage_key": "property/6767906449166342/019fce08-4c49-7252-89ac-296366e54629.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by the resort-style swimming pool, surrounded by comfortable lounge chairs and lush greenery.",
      "link": "false",
      "alt_text": "Outdoor apartment community pool with lounge chairs, clear water, and surrounding trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/67f352cd/dms3rep/multi/5767906449162442/6767906449166342/b229c3c3a35ed8f9d058b6c66cb157c2.jpg"
    },
    {
      "id": "custom_7c8c8bd5-de45-40fe-ac3a-45123ee7de8f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-4e29-7348-acb1-b83e3277ae7a.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and seating areas",
        "public_id": "019fce08-4e29-7348-acb1-b83e3277ae7a",
        "storage_key": "property/6767906449166342/019fce08-4e29-7348-acb1-b83e3277ae7a.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Outdoor pool at a multifamily community with lounge chairs, seating, and landscaped surroundings.",
      "link": "false",
      "alt_text": "Outdoor community pool area with lounge chairs and seating under trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/67f352cd/dms3rep/multi/5767906449162442/6767906449166342/92af4fbb9d1941d1cc6e80ba3ffecf6b.jpg"
    },
    {
      "id": "custom_78106a01-c479-4315-be17-67253566d037",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-536c-74ea-b151-4460d6189eb4.webp",
      "image_media": {
        "alt_text": "Fitness center gym with weight machines, medicine balls, and yoga mats.",
        "public_id": "019fce08-536c-74ea-b151-4460d6189eb4",
        "storage_key": "property/6767906449166342/019fce08-536c-74ea-b151-4460d6189eb4.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "On-site community gym featuring strength equipment, a weight bench, and a rack of medicine balls for residents.",
      "link": "false",
      "alt_text": "Interior fitness room with a multi-gym, weight bench, and colorful medicine balls near a window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/67f352cd/dms3rep/multi/5767906449162442/6767906449166342/a6f2e1c3e7b1f679697bb8aa36b8972b.jpg"
    },
    {
      "id": "custom_596c35d7-ba13-424b-8e8f-9069a3d69417",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-552e-7066-90e6-43643775c74f.webp",
      "image_media": {
        "alt_text": "Fitness center with weight rack, benches, and various exercise machines.",
        "public_id": "019fce08-552e-7066-90e6-43643775c74f",
        "storage_key": "property/6767906449166342/019fce08-552e-7066-90e6-43643775c74f.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "State-of-the-art fitness center equipped with cardio and strength training equipment to help you achieve your wellness goals.",
      "link": "false",
      "alt_text": "Well-equipped apartment fitness center with weight machines, benches, and a storage rack of medicine balls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/67f352cd/dms3rep/multi/5767906449162442/6767906449166342/5568ad426abfc2f590c9a84735d0f5b9.jpg"
    },
    {
      "id": "custom_c2748f5e-c78c-43be-ad11-83922dcfbe44",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-57bd-74fe-8226-0cc1974c37f9.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical, and stationary bike.",
        "public_id": "019fce08-57bd-74fe-8226-0cc1974c37f9",
        "storage_key": "property/6767906449166342/019fce08-57bd-74fe-8226-0cc1974c37f9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Well-equipped community fitness center featuring multiple treadmills and a stationary bike against an orange accent wall.",
      "link": "false",
      "alt_text": "Fitness center with three treadmills and a stationary bike by an orange wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/67f352cd/dms3rep/multi/5767906449162442/6767906449166342/75eac0cf9669a8cc0bbbf148577b873a.webp"
    },
    {
      "id": "custom_70418186-d684-41c3-852b-92ed69645fb9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-5a35-76fb-8c42-88be8eb55fd9.webp",
      "image_media": {
        "alt_text": "Playground with slide and swings, next to apartment buildings.",
        "public_id": "019fce08-5a35-76fb-8c42-88be8eb55fd9",
        "storage_key": "property/6767906449166342/019fce08-5a35-76fb-8c42-88be8eb55fd9.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Outdoor playground at a multifamily community with a blue spiral slide, climbing structures, and a picnic area.",
      "link": "false",
      "alt_text": "Playground with blue spiral slide and purple play structure at a brick apartment complex.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/67f352cd/dms3rep/multi/5767906449162442/6767906449166342/72afdd03f9072ee0340ad565a051e9a4.jpg"
    },
    {
      "id": "custom_fc271def-9c2c-439e-81fd-15751dbb328e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-6051-7659-8ebd-dfe9918b89f3.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a large island with a quartz countertop.",
        "public_id": "019fce08-6051-7659-8ebd-dfe9918b89f3",
        "storage_key": "property/6767906449166342/019fce08-6051-7659-8ebd-dfe9918b89f3.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Modern apartment kitchen with white cabinetry, stainless steel appliances, and a spacious island; features a large arched window for natural light.",
      "link": "false",
      "alt_text": "Bright kitchen with white cabinets, island, stainless appliances, and a large arched window with blinds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/67f352cd/dms3rep/multi/5767906449162442/6767906449166342/c54cbc8a91256716c527f1b062f4e826.jpg"
    },
    {
      "id": "custom_0c415861-edf0-409f-bb3e-0ba7fbdb32bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-6018-73e9-83f0-c7298c1828b9.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment and rules sign.",
        "public_id": "019fce08-6018-73e9-83f0-c7298c1828b9",
        "storage_key": "property/6767906449166342/019fce08-6018-73e9-83f0-c7298c1828b9.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Outdoor dog park at the community with signage, fencing, and basic play equipment for pets.",
      "link": "false",
      "alt_text": "Fenced dog park with a large Welcome to the Dog Park sign and small play structures.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/67f352cd/dms3rep/multi/5767906449162442/6767906449166342/acd870b45abd5701ccaca8385b8306fc.jpg"
    },
    {
      "id": "custom_99232045-93df-429c-b387-90949b4a0b42",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-63a4-723a-8abd-e6fe9de1c11e.webp",
      "image_media": {
        "alt_text": "Picnic area with grills and tables at a multifamily property.",
        "public_id": "019fce08-63a4-723a-8abd-e6fe9de1c11e",
        "storage_key": "property/6767906449166342/019fce08-63a4-723a-8abd-e6fe9de1c11e.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Shared outdoor seating and grilling area for residents, with trees and a brick apartment building in view.",
      "link": "false",
      "alt_text": "Outdoor communal picnic area with metal tables, grills, and trees near brick apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/67f352cd/dms3rep/multi/5767906449162442/6767906449166342/57320029758bc7e0956cfa372f0a90be.jpg"
    },
    {
      "id": "custom_c6f31ef9-4718-42ee-b346-65b2f0d0bd1d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-66ec-7111-945b-eeaf6a158e01.webp",
      "image_media": {
        "alt_text": "Exterior view of a red brick apartment building with arched windows and manicured landscaping.",
        "public_id": "019fce08-66ec-7111-945b-eeaf6a158e01",
        "storage_key": "property/6767906449166342/019fce08-66ec-7111-945b-eeaf6a158e01.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Welcome home to our charming apartment community, featuring beautifully maintained brick buildings and lush green spaces for a serene living experience.",
      "link": "false",
      "alt_text": "Exterior view of a brick apartment building with arched windows along a tree-lined street.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/67f352cd/dms3rep/multi/5767906449162442/6767906449166342/c307d21c942300c9d416d3659507cb20.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_9b96bd87-f2a0-4a22-9f5b-3c1e709bee7b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Bel Aire Pancake House",
      "poi_type": "Restaurants",
      "poi_address": "1613 E Little Creek Rd, Norfolk, VA 23518, USA",
      "poi_short_description": "Relaxed 1950s and 1960s-style diner in Larrymore Lawns serving up breakfast, as well as lunch and dinner.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-a426-7747-ba0a-e6a54fe3cce2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-a426-7747-ba0a-e6a54fe3cce2",
        "storage_key": "property/6767906449166342/019fce08-a426-7747-ba0a-e6a54fe3cce2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://belairepancakehouse.toast.site/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2228692105645412086&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bel-aire-pancake-house",
      "poi_latitude": "36.916533",
      "poi_longitude": "-76.230724",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 757-321-6226",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-6cf0-763a-80df-c997f1a010f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6cf0-763a-80df-c997f1a010f3",
        "storage_key": "property/6767906449166342/019d026b-6cf0-763a-80df-c997f1a010f3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjX5MnCyXuokR9k62dqnn7R4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c0ace2d4-33be-49bb-8a29-b6aab33956f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Starbucks",
      "poi_type": "Restaurants",
      "poi_address": "Suburban Park Shopping Center, 7550 Granby St, Norfolk, VA 23505, USA",
      "poi_short_description": "Seattle-based coffeehouse chain known for its signature roasts, light bites and WiFi availability.",
      "poi_long_description": "Seattle-based coffeehouse chain known for its signature roasts, light bites and WiFi availability.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-a4d7-72fb-b931-47ef5064704c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-a4d7-72fb-b931-47ef5064704c",
        "storage_key": "property/6767906449166342/019fce08-a4d7-72fb-b931-47ef5064704c.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.starbucks.com/store-locator/store/1006919/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17127152892930200201&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "starbucks",
      "poi_latitude": "36.91448",
      "poi_longitude": "-76.27065999999999",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 757-480-3893",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-6cf4-7076-a53a-0908d384d30a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6cf4-7076-a53a-0908d384d30a",
        "storage_key": "property/6767906449166342/019d026b-6cf4-7076-a53a-0908d384d30a.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJL9Wy31eXuokRiZLoBNDer-0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3151533a-aaa9-48c2-862a-3dbd0ec51e06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Black Rifle Coffee",
      "poi_type": "Restaurants",
      "poi_address": "216 E Little Creek Rd, Norfolk, VA 23505, USA",
      "poi_short_description": "Veteran-owned coffee shop supporting the military, first responders, and law enforcement with a 10% discount.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-a44c-7765-b41e-9aeaaec90774.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-a44c-7765-b41e-9aeaaec90774",
        "storage_key": "property/6767906449166342/019fce08-a44c-7765-b41e-9aeaaec90774.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://brccva.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1446045892996974519&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black-rifle-coffee",
      "poi_latitude": "36.91591",
      "poi_longitude": "-76.26952969999999",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 757-227-4072",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-6cf4-7076-a53a-0908d384d30a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6cf4-7076-a53a-0908d384d30a",
        "storage_key": "property/6767906449166342/019d026b-6cf4-7076-a53a-0908d384d30a.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ76ULesSXuokRt0f_BBRjERQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b5d4954e-a83c-458b-b607-d082774f5af4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Moe's Southwest Grill",
      "poi_type": "Restaurants",
      "poi_address": "7550 Granby St, Norfolk, VA 23505, USA",
      "poi_short_description": "Counter-serve chain dishing up Southwestern staples from burritos to nachos in lively environs.",
      "poi_long_description": "Counter-serve chain dishing up Southwestern staples from burritos to nachos in lively environs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-a4f8-738c-9840-db7e828b8081.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-a4f8-738c-9840-db7e828b8081",
        "storage_key": "property/6767906449166342/019fce08-a4f8-738c-9840-db7e828b8081.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.moes.com/va/norfolk/7550-granby-street?utm_source=google&utm_medium=organic&utm_campaign=locations_partner",
      "poi_directions_map_url": "https://maps.google.com/?cid=13790219757649664616&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "moes-southwest-grill",
      "poi_latitude": "36.9144325",
      "poi_longitude": "-76.2709102",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 757-309-4294",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-6cf0-763a-80df-c997f1a010f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6cf0-763a-80df-c997f1a010f3",
        "storage_key": "property/6767906449166342/019d026b-6cf0-763a-80df-c997f1a010f3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZWSqfP2ZuokRaBpITc6zYL8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_586b80a5-a144-4f32-8885-eadfee399307",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Your Pie Pizza",
      "poi_type": "Restaurants",
      "poi_address": "7550 Granby St #90, Norfolk, VA 23505, USA",
      "poi_short_description": "Diners choose their dough, sauce, cheese & toppings at this pizzeria chain with gelato & microbrews.",
      "poi_long_description": "Diners choose their dough, sauce, cheese & toppings at this pizzeria chain with gelato & microbrews.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-aae8-72a6-a6a8-3604b66e4430.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-aae8-72a6-a6a8-3604b66e4430",
        "storage_key": "property/6767906449166342/019fce08-aae8-72a6-a6a8-3604b66e4430.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.yourpie.com/locations/va/norfolk/7550-granby-street-ste-90/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9167923255312840559&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "your-pie-pizza",
      "poi_latitude": "36.9132966",
      "poi_longitude": "-76.2714038",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 757-502-7679",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-6cf0-763a-80df-c997f1a010f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6cf0-763a-80df-c997f1a010f3",
        "storage_key": "property/6767906449166342/019d026b-6cf0-763a-80df-c997f1a010f3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwT893leXuokRb_f2gKABO38",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_93bbd35b-aa6f-446e-aa29-41692ca6cd5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Chipotle Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "132 E Little Creek Rd, Norfolk, VA 23505, USA",
      "poi_short_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_long_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-aa83-740f-ab6d-03e3217986ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-aa83-740f-ab6d-03e3217986ab",
        "storage_key": "property/6767906449166342/019fce08-aa83-740f-ab6d-03e3217986ab.webp",
        "width": 954,
        "height": 954
      },
      "poi_business_url": "https://locations.chipotle.com/va/norfolk/132-e-little-creek-rd?utm_source=google&utm_medium=yext&utm_campaign=yext_listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=6512222753583034333&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chipotle-mexican-grill",
      "poi_latitude": "36.91527",
      "poi_longitude": "-76.27139",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 757-351-4401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-6cf0-763a-80df-c997f1a010f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6cf0-763a-80df-c997f1a010f3",
        "storage_key": "property/6767906449166342/019d026b-6cf0-763a-80df-c997f1a010f3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqzjK4q2ZuokR3W-IVRcQYFo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0dac2805-fbfc-4e8b-ae53-fd0c7e325822",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Firehouse Subs Wards Corner",
      "poi_type": "Restaurants",
      "poi_address": "124 E Little Creek Rd Ste 126, Norfolk, VA 23505, USA",
      "poi_short_description": "Counter-serve sandwich chain offering made-to-order hot & cold subs, plus a variety of hot sauces.",
      "poi_long_description": "Counter-serve sandwich chain offering made-to-order hot & cold subs, plus a variety of hot sauces.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-abc5-7288-899d-8bf19a84d191.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-abc5-7288-899d-8bf19a84d191",
        "storage_key": "property/6767906449166342/019fce08-abc5-7288-899d-8bf19a84d191.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://firehousesubs.com/menu?service-mode=TAKEOUT&store-number=1080",
      "poi_directions_map_url": "https://maps.google.com/?cid=12554519418310375011&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "firehouse-subs-wards-corner",
      "poi_latitude": "36.91537",
      "poi_longitude": "-76.271675",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 757-962-1401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-6cf0-763a-80df-c997f1a010f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6cf0-763a-80df-c997f1a010f3",
        "storage_key": "property/6767906449166342/019d026b-6cf0-763a-80df-c997f1a010f3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJsb_Ke_2ZuokRYzYi7uScOq4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8efd772a-9d97-4a11-b15e-2e185258ed0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "McDonald's",
      "poi_type": "Restaurants",
      "poi_address": "211 E Little Creek Rd, Norfolk, VA 23505, USA",
      "poi_short_description": "Classic, long-running fast-food chain known for its burgers & fries.",
      "poi_long_description": "Classic, long-running fast-food chain known for its burgers & fries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-abed-71d9-b395-be766c413cf5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-abed-71d9-b395-be766c413cf5",
        "storage_key": "property/6767906449166342/019fce08-abed-71d9-b395-be766c413cf5.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "https://www.mcdonalds.com/us/en-us/location/VA/NORFOLK/211-E-LITTLE-CREEK-RD/14052.html?cid=RF:YXT:GMB::Clicks",
      "poi_directions_map_url": "https://maps.google.com/?cid=10566790833436038090&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcdonalds",
      "poi_latitude": "36.91524709999999",
      "poi_longitude": "-76.26931259999999",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 757-480-3012",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-6cf0-763a-80df-c997f1a010f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6cf0-763a-80df-c997f1a010f3",
        "storage_key": "property/6767906449166342/019d026b-6cf0-763a-80df-c997f1a010f3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJV_sJTVaXuokRyhPPGkfIpJI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c0033065-a47f-4c12-983b-edacf3d2a3e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Wendy's",
      "poi_type": "Restaurants",
      "poi_address": "208 E Little Creek Rd, Norfolk, VA 23505, USA",
      "poi_short_description": "Fast-food burger chain serving sides such as chili & baked potatoes.",
      "poi_long_description": "Fast-food burger chain serving sides such as chili & baked potatoes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-b0c8-7675-9381-31b7c603f1a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-b0c8-7675-9381-31b7c603f1a8",
        "storage_key": "property/6767906449166342/019fce08-b0c8-7675-9381-31b7c603f1a8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.wendys.com/united-states/va/norfolk/208-e-little-creek?utm_source=Yext&utm_medium=Google_My_Business&utm_campaign=Local_Search&utm_content=EN_US",
      "poi_directions_map_url": "https://maps.google.com/?cid=1469004718662188941&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wendys",
      "poi_latitude": "36.915547",
      "poi_longitude": "-76.2699312",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 757-583-7092",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-6cf0-763a-80df-c997f1a010f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6cf0-763a-80df-c997f1a010f3",
        "storage_key": "property/6767906449166342/019d026b-6cf0-763a-80df-c997f1a010f3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ34rwOVaXuokRjX87LQL0YhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_973a5d1a-19d5-44f1-a6c9-43b7fee234c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Black Rifle Coffee",
      "poi_type": "Restaurants",
      "poi_address": "216 E Little Creek Rd, Norfolk, VA 23505, USA",
      "poi_short_description": "Veteran-owned coffee shop supporting the military, first responders, and law enforcement with a 10% discount.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-a44c-7765-b41e-9aeaaec90774.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-a44c-7765-b41e-9aeaaec90774",
        "storage_key": "property/6767906449166342/019fce08-a44c-7765-b41e-9aeaaec90774.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://brccva.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1446045892996974519&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black-rifle-coffee",
      "poi_latitude": "36.91591",
      "poi_longitude": "-76.26952969999999",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 757-227-4072",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-6cf4-7076-a53a-0908d384d30a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6cf4-7076-a53a-0908d384d30a",
        "storage_key": "property/6767906449166342/019d026b-6cf4-7076-a53a-0908d384d30a.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ76ULesSXuokRt0f_BBRjERQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_03def74f-fcfc-4a30-be7d-e2d51f7ba1a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "El Azteca - Norfolk",
      "poi_type": "Restaurants",
      "poi_address": "1522 E Little Creek Rd, Norfolk, VA 23518, USA",
      "poi_short_description": "One of a local chain offering Mexican staples & margaritas in cantina quarters with a patio.",
      "poi_long_description": "One of a local chain offering Mexican staples & margaritas in cantina quarters with a patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-b27f-7326-83b5-27e020eb78af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-b27f-7326-83b5-27e020eb78af",
        "storage_key": "property/6767906449166342/019fce08-b27f-7326-83b5-27e020eb78af.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://elaztecanorfolk.shop/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17312988283959778356&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-azteca---norfolk",
      "poi_latitude": "36.9169497",
      "poi_longitude": "-76.2326233",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 757-587-6016",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-6cf0-763a-80df-c997f1a010f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6cf0-763a-80df-c997f1a010f3",
        "storage_key": "property/6767906449166342/019d026b-6cf0-763a-80df-c997f1a010f3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJt78B6CyXuokRNBzsuR0XRPA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_81b4ebf0-5f32-4e10-a8c1-0e78d9c9f83c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Salmich's Burgers & Hoagies",
      "poi_type": "Restaurants",
      "poi_address": "1371 E Little Creek Rd, Norfolk, VA 23518, USA",
      "poi_short_description": "Casual sandwich spot offering a menu of subs, burgers, and sides, plus beer.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-b237-721c-86a1-649389284bdf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-b237-721c-86a1-649389284bdf",
        "storage_key": "property/6767906449166342/019fce08-b237-721c-86a1-649389284bdf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://salmichs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2581123097596735162&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "salmichs-burgers--hoagies",
      "poi_latitude": "36.915963",
      "poi_longitude": "-76.234383",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 757-587-7205",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-6cf0-763a-80df-c997f1a010f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6cf0-763a-80df-c997f1a010f3",
        "storage_key": "property/6767906449166342/019d026b-6cf0-763a-80df-c997f1a010f3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFzcQpy2XuokRui7PKcj90SM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e2fcf59b-d640-4239-9f8e-5ce88fd124a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "The Ten Top",
      "poi_type": "Restaurants",
      "poi_address": "748 Shirley Ave, Norfolk, VA 23517, USA",
      "poi_short_description": "Storefront American joint dishing out sandwiches, salads & full dinners, with vegetarian options.",
      "poi_long_description": "Storefront American joint dishing out sandwiches, salads & full dinners, with vegetarian options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-b2de-71f4-a113-9b5d50502561.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-b2de-71f4-a113-9b5d50502561",
        "storage_key": "property/6767906449166342/019fce08-b2de-71f4-a113-9b5d50502561.webp",
        "width": 1280,
        "height": 1206
      },
      "poi_business_url": "https://thetentop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=718522586580550609&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-ten-top",
      "poi_latitude": "36.86801700000001",
      "poi_longitude": "-76.2974002",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 757-622-5422",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-6cf0-763a-80df-c997f1a010f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6cf0-763a-80df-c997f1a010f3",
        "storage_key": "property/6767906449166342/019d026b-6cf0-763a-80df-c997f1a010f3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJG2xpK0GYuokR0YM6UHy0-Ak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1eeb556b-491d-46ec-b29b-c588e63babc2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Saltine",
      "poi_type": "Restaurants",
      "poi_address": "100 E Main St, Norfolk, VA 23510, USA",
      "poi_short_description": "Spacious, brick-clad eatery offering seafood, oysters & fresh produce plus cocktails & beer.",
      "poi_long_description": "Spacious, brick-clad eatery offering seafood, oysters & fresh produce plus cocktails & beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-b7d5-7672-bbbf-989f2ae7276a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-b7d5-7672-bbbf-989f2ae7276a",
        "storage_key": "property/6767906449166342/019fce08-b7d5-7672-bbbf-989f2ae7276a.webp",
        "width": 1280,
        "height": 742
      },
      "poi_business_url": "https://saltinenorfolk.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17722241654984697495&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saltine",
      "poi_latitude": "36.8465694",
      "poi_longitude": "-76.29205",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 757-763-6280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-6cf0-763a-80df-c997f1a010f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6cf0-763a-80df-c997f1a010f3",
        "storage_key": "property/6767906449166342/019d026b-6cf0-763a-80df-c997f1a010f3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJP-9LggyYuokRl2b-hOMM8vU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_feb3ea46-ce12-4b77-953e-048320fed4bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping",
      "poi_address": "7431 Tidewater Dr, Norfolk, VA 23505, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-b8ff-722b-9b5e-039b9ff165be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-b8ff-722b-9b5e-039b9ff165be",
        "storage_key": "property/6767906449166342/019fce08-b8ff-722b-9b5e-039b9ff165be.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.7-eleven.com/locations/va/norfolk/7431-tidewater-dr-19108?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=867790016034629373&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "36.9096437",
      "poi_longitude": "-76.2569072",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 757-583-3607",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-6cf3-755f-b984-8fc521ac6d91.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6cf3-755f-b984-8fc521ac6d91",
        "storage_key": "property/6767906449166342/019d026b-6cf3-755f-b984-8fc521ac6d91.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJx9RsdUWXuokR_eZf_WsCCww",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2a812375-c74d-4a50-9b25-83ae424e732d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Citgo",
      "poi_type": "Shopping",
      "poi_address": "303 E Little Creek Rd, Norfolk, VA 23505, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5940745036038221528&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "citgo",
      "poi_latitude": "36.9176823",
      "poi_longitude": "-76.2647465",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 757-588-5760",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-6d48-76de-a09c-e40ce6b36e2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-6d48-76de-a09c-e40ce6b36e2a",
        "storage_key": "property/6767906449166342/019d026b-6d48-76de-a09c-e40ce6b36e2a.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJNZB48FOXuokR2C45hiLEcVI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2749518e-423c-47e7-ba54-dedc96ef89f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping",
      "poi_address": "115 W Little Creek Rd Walgreens, Norfolk, VA 23505, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-b8e6-764d-a212-8672e6293f22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-b8e6-764d-a212-8672e6293f22",
        "storage_key": "property/6767906449166342/019fce08-b8e6-764d-a212-8672e6293f22.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-115+w+little+creek+rd-norfolk-va-23505/id=5876",
      "poi_directions_map_url": "https://maps.google.com/?cid=2943149986661321089&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "36.9144051",
      "poi_longitude": "-76.2734514",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 757-489-5291",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-71cf-7574-b4c4-e33d08f8aa66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71cf-7574-b4c4-e33d08f8aa66",
        "storage_key": "property/6767906449166342/019d026b-71cf-7574-b4c4-e33d08f8aa66.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM61_A_2ZuokRgcmkw1Er2Cg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_499a7f2d-90f9-4eb7-be4d-be7c01704d72",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Shopping",
      "poi_address": "4261 E Little Creek Rd, Norfolk, VA 23518, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-b941-71c9-a623-a7849c886189.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-b941-71c9-a623-a7849c886189",
        "storage_key": "property/6767906449166342/019fce08-b941-71c9-a623-a7849c886189.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cvs.com/store-locator/norfolk-va-pharmacies/4261-e-little-creek-rd-norfolk-va-23518/storeid=6146?WT.mc_id=LS_GOOGLE_FS_6146",
      "poi_directions_map_url": "https://maps.google.com/?cid=13889949821512661681&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "36.9175767",
      "poi_longitude": "-76.19310589999999",
      "poi_miles_from_property": "8.9 mi",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 757-588-0123",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-71cf-7574-b4c4-e33d08f8aa66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71cf-7574-b4c4-e33d08f8aa66",
        "storage_key": "property/6767906449166342/019d026b-71cf-7574-b4c4-e33d08f8aa66.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj6quN0yRuokRsTpDQ8UDw8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_429ac8e8-248e-4971-8d68-8d6791f6c8b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Food Lion",
      "poi_type": "Shopping",
      "poi_address": "8401 Hampton Blvd, Norfolk, VA 23505, USA",
      "poi_short_description": "Grocery outlet offering a variety of bulk and organic products, plus prepared foods.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-bec5-739b-822c-86d2b9059fec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-bec5-739b-822c-86d2b9059fec",
        "storage_key": "property/6767906449166342/019fce08-bec5-739b-822c-86d2b9059fec.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://stores.foodlion.com/va/norfolk/8401-hampton-bvld.?y_source=1_NTA0NjM5OS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=4872567563155506354&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "food-lion",
      "poi_latitude": "36.9293841",
      "poi_longitude": "-76.32002059999999",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 757-489-2717",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-71cc-742e-9ae7-bffc9eaa132e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71cc-742e-9ae7-bffc9eaa132e",
        "storage_key": "property/6767906449166342/019d026b-71cc-742e-9ae7-bffc9eaa132e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ49-TetWbuokRsoT5-WHWnkM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_292a673d-9b83-487c-ab49-cfacf08e74fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Harris Teeter",
      "poi_type": "Shopping",
      "poi_address": "7550 Granby St, Norfolk, VA 23505, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty aids.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty aids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-bf86-7703-9e06-737983b24416.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-bf86-7703-9e06-737983b24416",
        "storage_key": "property/6767906449166342/019fce08-bf86-7703-9e06-737983b24416.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.harristeeter.com/stores/grocery/va/norfolk/k-k-square-at-wards-corner/097/00407?cid=loc_09700407_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=5451183858315536389&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harris-teeter",
      "poi_latitude": "36.9137509",
      "poi_longitude": "-76.27087639999999",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 757-588-4260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-71cc-742e-9ae7-bffc9eaa132e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71cc-742e-9ae7-bffc9eaa132e",
        "storage_key": "property/6767906449166342/019d026b-71cc-742e-9ae7-bffc9eaa132e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB9Qhaf2ZuokRBag9aNZ-pks",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_885a0324-06d0-407d-8170-443dfbf406b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping",
      "poi_address": "7734-A Hampton Blvd, Norfolk, VA 23505, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-bf1c-750b-8abc-6310189e1aab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-bf1c-750b-8abc-6310189e1aab",
        "storage_key": "property/6767906449166342/019fce08-bf1c-750b-8abc-6310189e1aab.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://locations.dollartree.com/va/norfolk/7734a-hampton-blvd?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=3515783275811041925&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "36.9171664",
      "poi_longitude": "-76.30842249999999",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 757-257-0629",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-7216-741e-8be2-bb8bfab3f782.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-7216-741e-8be2-bb8bfab3f782",
        "storage_key": "property/6767906449166342/019d026b-7216-741e-8be2-bb8bfab3f782.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhTl5KYWZuokRhfL5DUOSyjA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_54e1ed58-6aea-4cc8-b90e-92f5211a702a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping",
      "poi_address": "3350 E Princess Anne Rd, Norfolk, VA 23502, USA",
      "poi_short_description": "Neighborhood grocery store stocking household supplies, electronics and clothing, plus a pharmacy.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-bfed-72aa-9c1a-95a7bee82ed7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-bfed-72aa-9c1a-95a7bee82ed7",
        "storage_key": "property/6767906449166342/019fce08-bfed-72aa-9c1a-95a7bee82ed7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/6798-norfolk-va/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=6652181970488791230&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "36.8635331",
      "poi_longitude": "-76.2462366",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 757-216-0632",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-71cc-742e-9ae7-bffc9eaa132e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71cc-742e-9ae7-bffc9eaa132e",
        "storage_key": "property/6767906449166342/019d026b-71cc-742e-9ae7-bffc9eaa132e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ77Cax72XuokRvhA-5EFMUVw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7821a33b-74fd-4df1-b0a9-532ec58e66b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping",
      "poi_address": "730 W 21st St, Norfolk, VA 23517, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-c4e0-77eb-987f-a3df7502f6f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-c4e0-77eb-987f-a3df7502f6f0",
        "storage_key": "property/6767906449166342/019fce08-c4e0-77eb-987f-a3df7502f6f0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://stores.aldi.us/va/norfolk/730-west-21st-street?utm_source=google&utm_medium=local&utm_campaign=brand&utm_content=storepage_webclick",
      "poi_directions_map_url": "https://maps.google.com/?cid=6378084000241488722&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "36.8704038",
      "poi_longitude": "-76.2941602",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-71cc-742e-9ae7-bffc9eaa132e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71cc-742e-9ae7-bffc9eaa132e",
        "storage_key": "property/6767906449166342/019d026b-71cc-742e-9ae7-bffc9eaa132e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ748Xq_WZuokRUhP_DZuBg1g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_14a08040-6589-4d2e-8e26-261c2c59d914",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping",
      "poi_address": "850 Glenrock Rd #202b, Norfolk, VA 23502, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-c505-72a1-bb7e-2bc2b3bbc0fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-c505-72a1-bb7e-2bc2b3bbc0fa",
        "storage_key": "property/6767906449166342/019fce08-c505-72a1-bb7e-2bc2b3bbc0fa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/norfolk-VA-202.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=12919072975057584880&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "36.852332",
      "poi_longitude": "-76.1987532",
      "poi_miles_from_property": "10.9 mi",
      "poi_walking_minutes": "4 hours 8 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 757-459-4471",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-7216-741e-8be2-bb8bfab3f782.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-7216-741e-8be2-bb8bfab3f782",
        "storage_key": "property/6767906449166342/019d026b-7216-741e-8be2-bb8bfab3f782.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJL3gTzGqWuokR8AKoMWzESbM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5ddfc5e9-84f8-4d61-b23f-c858b959812a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Granby High School",
      "poi_type": "Education",
      "poi_address": "7101 Granby St, Norfolk, VA 23505, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-c684-73bd-9a4f-4893a77a720f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-c684-73bd-9a4f-4893a77a720f",
        "storage_key": "property/6767906449166342/019fce08-c684-73bd-9a4f-4893a77a720f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.npsk12.com/ghs",
      "poi_directions_map_url": "https://maps.google.com/?cid=9573129430911639354&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "granby-high-school",
      "poi_latitude": "36.9069865",
      "poi_longitude": "-76.2773897",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 757-451-4110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-71c9-741d-a2e0-8337862e790b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71c9-741d-a2e0-8337862e790b",
        "storage_key": "property/6767906449166342/019d026b-71c9-741d-a2e0-8337862e790b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDfrSvOaZuokROl9TLn-W2oQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_721fb002-0aa0-492c-9415-aec7b183bbea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Granby Elementary School",
      "poi_type": "Education",
      "poi_address": "7101 Newport Ave, Norfolk, VA 23505, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-c6f5-755e-8030-246e3406de57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-c6f5-755e-8030-246e3406de57",
        "storage_key": "property/6767906449166342/019fce08-c6f5-755e-8030-246e3406de57.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.npsk12.com/ges",
      "poi_directions_map_url": "https://maps.google.com/?cid=7064775863341721454&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "granby-elementary-school",
      "poi_latitude": "36.9079476",
      "poi_longitude": "-76.2811291",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 757-451-4150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-71c9-741d-a2e0-8337862e790b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71c9-741d-a2e0-8337862e790b",
        "storage_key": "property/6767906449166342/019d026b-71c9-741d-a2e0-8337862e790b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnUFVCeaZuokRbqc8iDcgC2I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_eb35ad34-6a85-436e-8b1a-f1d0d738c6c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Camp Allen Elementary",
      "poi_type": "Education",
      "poi_address": "501 C St, Norfolk, VA 23505, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-cb2b-75ba-b177-d31f51e15764.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-cb2b-75ba-b177-d31f51e15764",
        "storage_key": "property/6767906449166342/019fce08-cb2b-75ba-b177-d31f51e15764.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.npsk12.com/caes",
      "poi_directions_map_url": "https://maps.google.com/?cid=697791231318277715&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "camp-allen-elementary",
      "poi_latitude": "36.9285864",
      "poi_longitude": "-76.2967778",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 757-451-4170",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-71c9-741d-a2e0-8337862e790b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71c9-741d-a2e0-8337862e790b",
        "storage_key": "property/6767906449166342/019d026b-71c9-741d-a2e0-8337862e790b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5R0_qyGauokRU74bhm0Nrwk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8db765d6-5aab-4f6f-adc0-1e6ff510888b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Sewells Point Elementary",
      "poi_type": "Education",
      "poi_address": "7928 Hampton Blvd, Norfolk, VA 23505, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-cb72-702a-be9c-da99366473d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-cb72-702a-be9c-da99366473d9",
        "storage_key": "property/6767906449166342/019fce08-cb72-702a-be9c-da99366473d9.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "http://schools.nps.k12.va.us/spes/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13731430999626436026&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sewells-point-elementary",
      "poi_latitude": "36.9225662",
      "poi_longitude": "-76.31410989999999",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 757-451-4160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-71c9-741d-a2e0-8337862e790b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71c9-741d-a2e0-8337862e790b",
        "storage_key": "property/6767906449166342/019d026b-71c9-741d-a2e0-8337862e790b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJoZCW14OZuokRuk2F7r3Xj74",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7357c3af-61ff-4c72-98b2-c8fc63d3c217",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Suburban Park Elementary School",
      "poi_type": "Education",
      "poi_address": "310 Thole St, Norfolk, VA 23505, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.npsk12.com/ses",
      "poi_directions_map_url": "https://maps.google.com/?cid=16017465379358223382&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "suburban-park-elementary-school",
      "poi_latitude": "36.905775",
      "poi_longitude": "-76.26800759999999",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 757-531-3118",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-71c9-741d-a2e0-8337862e790b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71c9-741d-a2e0-8337862e790b",
        "storage_key": "property/6767906449166342/019d026b-71c9-741d-a2e0-8337862e790b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJj5cb316XuokRFqzD-uV3Sd4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cd7d37e5-58e7-415f-be26-a36a8d25bfb8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Norfolk Collegiate",
      "poi_type": "Education",
      "poi_address": "7336 Granby St, Norfolk, VA 23505, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-cd7c-77fc-8980-fe7523b8f0ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-cd7c-77fc-8980-fe7523b8f0ec",
        "storage_key": "property/6767906449166342/019fce08-cd7c-77fc-8980-fe7523b8f0ec.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://www.norfolkcollegiate.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13240609063037062121&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "norfolk-collegiate",
      "poi_latitude": "36.9105989",
      "poi_longitude": "-76.2740507",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 757-480-2885",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-71c9-741d-a2e0-8337862e790b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71c9-741d-a2e0-8337862e790b",
        "storage_key": "property/6767906449166342/019d026b-71c9-741d-a2e0-8337862e790b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ1zJk-KZuokR6UskhMoXwLc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5dd13b6c-1ba9-4dcf-8e56-e5d5603f8eab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Norfolk Christian Schools",
      "poi_type": "Education",
      "poi_address": "255 Thole St, Norfolk, VA 23505, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-ccc6-719e-985f-2e6be4886aaa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-ccc6-719e-985f-2e6be4886aaa",
        "storage_key": "property/6767906449166342/019fce08-ccc6-719e-985f-2e6be4886aaa.webp",
        "width": 508,
        "height": 284
      },
      "poi_business_url": "http://www.norfolkchristian.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4121579296194471816&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "norfolk-christian-schools",
      "poi_latitude": "36.90441879999999",
      "poi_longitude": "-76.2712643",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 757-423-5770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-71c9-741d-a2e0-8337862e790b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71c9-741d-a2e0-8337862e790b",
        "storage_key": "property/6767906449166342/019d026b-71c9-741d-a2e0-8337862e790b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKb9vgV-XuokRiKdGZ4jKMjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0d024441-1dfe-4dfb-9910-e75807a4831a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Loch-Meadow Kindergarten",
      "poi_type": "Education",
      "poi_address": "7400 Hampton Blvd, Norfolk, VA 23505, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.loch-meadowkindergarten.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5381967110690552777&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "loch-meadow-kindergarten",
      "poi_latitude": "36.9117991",
      "poi_longitude": "-76.3054647",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 757-489-2008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-71c9-741d-a2e0-8337862e790b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71c9-741d-a2e0-8337862e790b",
        "storage_key": "property/6767906449166342/019d026b-71c9-741d-a2e0-8337862e790b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQfwYqJCZuokRybuLgZKWsEo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_976a28eb-b531-44d3-a14a-13f20eca1e2f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Tidewater Community College - Norfolk Campus",
      "poi_type": "Education",
      "poi_address": "300 Granby St, Norfolk, VA 23510, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-d12a-7288-9112-96d01b7cd31c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-d12a-7288-9112-96d01b7cd31c",
        "storage_key": "property/6767906449166342/019fce08-d12a-7288-9112-96d01b7cd31c.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "https://www.tcc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14634708013926114657&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tidewater-community-college---norfolk-campus",
      "poi_latitude": "36.849878",
      "poi_longitude": "-76.2902944",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 757-822-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-71c9-741d-a2e0-8337862e790b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71c9-741d-a2e0-8337862e790b",
        "storage_key": "property/6767906449166342/019d026b-71c9-741d-a2e0-8337862e790b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQ5zyvg2YuokRYeWgkWbtGMs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4f7e3df3-52ef-4320-97f9-5453cccebc50",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "5115 Hampton Blvd",
      "poi_type": "Education",
      "poi_address": "5115 Hampton Blvd, Norfolk, VA 23508, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?q=5115+Hampton+Blvd,+Norfolk,+VA+23508,+USA&ftid=0x89ba99b3aa427b3d:0x40772fd35a288a02&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "5115-hampton-blvd",
      "poi_latitude": "36.8876492",
      "poi_longitude": "-76.30307959999999",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-71cf-7574-b4c4-e33d08f8aa66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71cf-7574-b4c4-e33d08f8aa66",
        "storage_key": "property/6767906449166342/019d026b-71cf-7574-b4c4-e33d08f8aa66.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "Eik1MTE1IEhhbXB0b24gQmx2ZCwgTm9yZm9saywgVkEgMjM1MDgsIFVTQSIxEi8KFAoSCT17QqqzmbqJEc8kVc75cAgJEPsnKhQKEgk7N0eXzJu6iRG9dDCWGjTEjw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f2fb27b2-3f51-4ead-ab2d-1dcae0cd1ad7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "The NorVa",
      "poi_type": "Entertainment",
      "poi_address": "317 Monticello Ave, Norfolk, VA 23510, USA",
      "poi_short_description": "Downtown music venue for national indie bands with a general admission floor & a small balcony.",
      "poi_long_description": "Downtown music venue for national indie bands with a general admission floor & a small balcony.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-d239-716c-ae98-35af401648ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-d239-716c-ae98-35af401648ab",
        "storage_key": "property/6767906449166342/019fce08-d239-716c-ae98-35af401648ab.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "http://www.thenorva.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10866326690772284751&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-norva",
      "poi_latitude": "36.850189",
      "poi_longitude": "-76.28949999999999",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 757-627-4547",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-71cf-7574-b4c4-e33d08f8aa66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71cf-7574-b4c4-e33d08f8aa66",
        "storage_key": "property/6767906449166342/019d026b-71cf-7574-b4c4-e33d08f8aa66.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBXJH6Q2YuokRT_XTkI3yzJY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5454d80b-f280-40dd-ae34-2a6915f82821",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Regal Macarthur Center",
      "poi_type": "Entertainment",
      "poi_address": "300 Monticello Ave Suite 330, Norfolk, VA 23510, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-d2f0-718e-b131-38d8f9c39f38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-d2f0-718e-b131-38d8f9c39f38",
        "storage_key": "property/6767906449166342/019fce08-d2f0-718e-b131-38d8f9c39f38.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-macarthur-center-rpx-0365?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=12127606468421308660&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-macarthur-center",
      "poi_latitude": "36.8489592",
      "poi_longitude": "-76.2882654",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-7740-7239-9553-7b0f665c3ecd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-7740-7239-9553-7b0f665c3ecd",
        "storage_key": "property/6767906449166342/019d026b-7740-7239-9553-7b0f665c3ecd.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJQUA_xA2YuokR9FD7BdTpTag",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_75a8e842-7683-4d0b-a86c-894d9b415c06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Nauticus",
      "poi_type": "Entertainment",
      "poi_address": "1 Waterside Dr Suite 248, Norfolk, VA 23510, USA",
      "poi_short_description": "Waterfront maritime museum with science exhibits, an aquarium & a historic battleship.",
      "poi_long_description": "Waterfront maritime museum with science exhibits, an aquarium & a historic battleship.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-d31a-7748-b42b-b3d6f172edee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-d31a-7748-b42b-b3d6f172edee",
        "storage_key": "property/6767906449166342/019fce08-d31a-7748-b42b-b3d6f172edee.webp",
        "width": 960,
        "height": 539
      },
      "poi_business_url": "http://www.nauticus.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=320581371750534560&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nauticus",
      "poi_latitude": "36.8477024",
      "poi_longitude": "-76.29509139999999",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 757-664-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-77e0-70f1-93ff-6908a3594602.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-77e0-70f1-93ff-6908a3594602",
        "storage_key": "property/6767906449166342/019d026b-77e0-70f1-93ff-6908a3594602.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJiQ2IUnOYuokRoE3MIA_vcgQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a2b38710-e914-4425-b57b-8078b21d9cf9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Virginia Zoo",
      "poi_type": "Entertainment",
      "poi_address": "3500 Granby St, Norfolk, VA 23504, USA",
      "poi_short_description": "Sprawling park with 700+ animals from 150+ species, plus tours, gardens & kids' camps.",
      "poi_long_description": "Sprawling park with 700+ animals from 150+ species, plus tours, gardens & kids' camps.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-d7db-738c-a2e2-001be68b1592.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-d7db-738c-a2e2-001be68b1592",
        "storage_key": "property/6767906449166342/019fce08-d7db-738c-a2e2-001be68b1592.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.virginiazoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1690277800201406272&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "virginia-zoo",
      "poi_latitude": "36.8767691",
      "poi_longitude": "-76.2771229",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 757-441-2374",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-71cf-7574-b4c4-e33d08f8aa66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71cf-7574-b4c4-e33d08f8aa66",
        "storage_key": "property/6767906449166342/019d026b-71cf-7574-b4c4-e33d08f8aa66.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoXYXhiuYuokRQMe7LLQSdRc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b4727379-2d0f-40e2-9ed7-d6ca680cdbac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Chrysler Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "Chrysler Museum of Art, 1 Memorial Pl, Norfolk, VA 23510, USA",
      "poi_short_description": "Esteemed museum with a broad collection of ancient to contemporary art, including glass & sculpture.",
      "poi_long_description": "Esteemed museum with a broad collection of ancient to contemporary art, including glass & sculpture.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-d8e1-7129-b8b3-02862be30ae9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-d8e1-7129-b8b3-02862be30ae9",
        "storage_key": "property/6767906449166342/019fce08-d8e1-7129-b8b3-02862be30ae9.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.chrysler.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15237537796494747209&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chrysler-museum-of-art",
      "poi_latitude": "36.8563889",
      "poi_longitude": "-76.2930556",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 757-664-6200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-77e0-70f1-93ff-6908a3594602.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-77e0-70f1-93ff-6908a3594602",
        "storage_key": "property/6767906449166342/019d026b-77e0-70f1-93ff-6908a3594602.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJVwT-nRSYuokRSWao2-SbdtM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_122ccf02-384c-4a43-8617-ce8e2c627267",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Norfolk Tides at Harbor Park Stadium",
      "poi_type": "Entertainment",
      "poi_address": "150 Park Ave, Norfolk, VA 23510, USA",
      "poi_short_description": "Home to the triple-A Tidewater Tides, this 12,000-seat baseball stadium sits on the Elizabeth River.",
      "poi_long_description": "Home to the triple-A Tidewater Tides, this 12,000-seat baseball stadium sits on the Elizabeth River.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-d98d-73a5-9461-72f49a6b9df2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-d98d-73a5-9461-72f49a6b9df2",
        "storage_key": "property/6767906449166342/019fce08-d98d-73a5-9461-72f49a6b9df2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.norfolktides.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=175833262768201225&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "norfolk-tides-at-harbor-park-stadium",
      "poi_latitude": "36.8431872",
      "poi_longitude": "-76.2794548",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 757-622-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-77e3-7107-b961-b2541d6aa864.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-77e3-7107-b961-b2541d6aa864",
        "storage_key": "property/6767906449166342/019d026b-77e3-7107-b961-b2541d6aa864.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJoQNa6AaYuokRCR7_vmuvcAI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_37b9fe08-a8b1-4cf6-b005-099e9aa59498",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Chrysler Hall",
      "poi_type": "Entertainment",
      "poi_address": "215 St Pauls Blvd, Norfolk, VA 23510, USA",
      "poi_short_description": "Concert & theater venue hosting cultural events like ballet, musicals & orchestral performances.",
      "poi_long_description": "Concert & theater venue hosting cultural events like ballet, musicals & orchestral performances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-d993-712f-8f65-fee883e98f04.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-d993-712f-8f65-fee883e98f04",
        "storage_key": "property/6767906449166342/019fce08-d993-712f-8f65-fee883e98f04.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.sevenvenues.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2138802099577765862&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chrysler-hall",
      "poi_latitude": "36.8520687",
      "poi_longitude": "-76.2860634",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 757-664-6464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-71cf-7574-b4c4-e33d08f8aa66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71cf-7574-b4c4-e33d08f8aa66",
        "storage_key": "property/6767906449166342/019d026b-71cf-7574-b4c4-e33d08f8aa66.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY5fo_RCYuokR5j8xfi2Nrh0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e2abc479-4135-47f3-a13b-e7d30d3086de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Norfolk Scope Arena",
      "poi_type": "Entertainment",
      "poi_address": "201 E Brambleton Ave, Norfolk, VA 23510, USA",
      "poi_short_description": "Venue for hockey, basketball, concert and circus events, plus featuring friendly staff.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-df85-7074-840d-6661d3c90e18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-df85-7074-840d-6661d3c90e18",
        "storage_key": "property/6767906449166342/019fce08-df85-7074-840d-6661d3c90e18.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.sevenvenues.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7342986739051823359&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "norfolk-scope-arena",
      "poi_latitude": "36.8532544",
      "poi_longitude": "-76.28687800000002",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 757-664-6464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-71cf-7574-b4c4-e33d08f8aa66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71cf-7574-b4c4-e33d08f8aa66",
        "storage_key": "property/6767906449166342/019d026b-71cf-7574-b4c4-e33d08f8aa66.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY5fo_RCYuokR_4CWy4iH52U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cd35f841-bae1-4d16-bbcf-041cda3a73cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Portsmouth Pavilion",
      "poi_type": "Entertainment",
      "poi_address": "16 Crawford Cir, Portsmouth, VA 23704, USA",
      "poi_short_description": "Seasonal outdoor amphitheater for big-name bands, holding 7,500, both in seats & on the lawn.",
      "poi_long_description": "Seasonal outdoor amphitheater for big-name bands, holding 7,500, both in seats & on the lawn.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-dfbc-73a9-a72e-7f6d8ce0d4d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-dfbc-73a9-a72e-7f6d8ce0d4d8",
        "storage_key": "property/6767906449166342/019fce08-dfbc-73a9-a72e-7f6d8ce0d4d8.webp",
        "width": 1280,
        "height": 867
      },
      "poi_business_url": "http://www.pavilionconcerts.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13834652520002649134&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "portsmouth-pavilion",
      "poi_latitude": "36.83158299999999",
      "poi_longitude": "-76.29778739999999",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 757-393-8181",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-71cf-7574-b4c4-e33d08f8aa66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71cf-7574-b4c4-e33d08f8aa66",
        "storage_key": "property/6767906449166342/019d026b-71cf-7574-b4c4-e33d08f8aa66.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQfPPsZmiuokRLny49SqP_r8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d9506b5f-e97a-48b1-8c7b-4cc1345b7b6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "MacArthur Memorial",
      "poi_type": "Entertainment",
      "poi_address": "198 Bank St, Norfolk, VA 23510, USA",
      "poi_short_description": "Exhibits, learning center & theater honoring Douglas MacArthur & vets of WWI, WWII & the Korean War.",
      "poi_long_description": "Exhibits, learning center & theater honoring Douglas MacArthur & vets of WWI, WWII & the Korean War.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-dfdd-713f-ac35-a75a11af46a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-dfdd-713f-ac35-a75a11af46a2",
        "storage_key": "property/6767906449166342/019fce08-dfdd-713f-ac35-a75a11af46a2.webp",
        "width": 1280,
        "height": 731
      },
      "poi_business_url": "http://www.macarthurmemorial.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5309486201339235750&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "macarthur-memorial",
      "poi_latitude": "36.8473833",
      "poi_longitude": "-76.28873589999999",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 757-441-2965",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-77e0-70f1-93ff-6908a3594602.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-77e0-70f1-93ff-6908a3594602",
        "storage_key": "property/6767906449166342/019d026b-77e0-70f1-93ff-6908a3594602.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJi66QIQyYuokRps2pupEVr0k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a67f93dd-78a6-4c17-95dc-6841628d236d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Sentara Norfolk General Hospital",
      "poi_type": "Health",
      "poi_address": "600 Gresham Dr, Norfolk, VA 23507, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-e022-7119-af3a-5c2d91736a4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-e022-7119-af3a-5c2d91736a4e",
        "storage_key": "property/6767906449166342/019fce08-e022-7119-af3a-5c2d91736a4e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.sentara.com/hospitalslocations/sentara-norfolk-general-hospital/directions-parking",
      "poi_directions_map_url": "https://maps.google.com/?cid=3954889307129810351&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sentara-norfolk-general-hospital",
      "poi_latitude": "36.8623012",
      "poi_longitude": "-76.3032334",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 757-388-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-779a-777e-9f08-6f8ee7cc1cdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-779a-777e-9f08-6f8ee7cc1cdb",
        "storage_key": "property/6767906449166342/019d026b-779a-777e-9f08-6f8ee7cc1cdb.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJnUEuMGiYuokRr4129d6W4jY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1429cb02-1cfc-47fd-830f-1112e69939bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Sentara Urgent Care",
      "poi_type": "Health",
      "poi_address": "7435 Granby St, Norfolk, VA 23505, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-e56d-76a8-af04-a68ab8192d74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-e56d-76a8-af04-a68ab8192d74",
        "storage_key": "property/6767906449166342/019fce08-e56d-76a8-af04-a68ab8192d74.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.sentara.com/hospitalslocations/sentara-urgent-care/locations/sentara-urgent-care-wards-corner",
      "poi_directions_map_url": "https://maps.google.com/?cid=5057212262691176992&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sentara-urgent-care",
      "poi_latitude": "36.9133226",
      "poi_longitude": "-76.2735496",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 757-702-8101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-71cf-7574-b4c4-e33d08f8aa66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71cf-7574-b4c4-e33d08f8aa66",
        "storage_key": "property/6767906449166342/019d026b-71cf-7574-b4c4-e33d08f8aa66.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrT8kKyyZuokRIAJ1N8LTLkY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_63a0026d-a093-4a56-90e5-7ba7f7a45dcb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Fort Norfolk Plaza Urgent Care",
      "poi_type": "Health",
      "poi_address": "301 Riverview Ave #502, Norfolk, VA 23510, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://fortnorfolkmedical.com/urgent-care/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5721727214205968581&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-norfolk-plaza-urgent-care",
      "poi_latitude": "36.8594692",
      "poi_longitude": "-76.3064662",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 757-333-0284",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-71cf-7574-b4c4-e33d08f8aa66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71cf-7574-b4c4-e33d08f8aa66",
        "storage_key": "property/6767906449166342/019d026b-71cf-7574-b4c4-e33d08f8aa66.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO25_GmaYuokRxaBuGJaoZ08",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_83e62018-a76d-4aad-a27f-57b5000e0053",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health",
      "poi_address": "7530 Tidewater Dr, Norfolk, VA 23505, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-e5fb-72e1-9876-0bd3285d6c0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-e5fb-72e1-9876-0bd3285d6c0a",
        "storage_key": "property/6767906449166342/019fce08-e5fb-72e1-9876-0bd3285d6c0a.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/5488-norfolk-va/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=17941359041556574537&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "36.9127183",
      "poi_longitude": "-76.2520759",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 757-480-3051",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-7d9e-757b-9050-d2b02c8d327b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-7d9e-757b-9050-d2b02c8d327b",
        "storage_key": "property/6767906449166342/019d026b-7d9e-757b-9050-d2b02c8d327b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrdwLrEuXuokRSfG4q_2C_Pg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0f88c1bb-7a04-4503-b95c-80f368ed67bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health",
      "poi_address": "8609 Tidewater Dr, Norfolk, VA 23503, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-e718-7068-a87d-fa2d584e91fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-e718-7068-a87d-fa2d584e91fa",
        "storage_key": "property/6767906449166342/019fce08-e718-7068-a87d-fa2d584e91fa.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-8609+tidewater+dr-norfolk-va-23503/id=7117",
      "poi_directions_map_url": "https://maps.google.com/?cid=1446016819133653431&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "36.9332641",
      "poi_longitude": "-76.2546474",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 757-583-2274",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-71cf-7574-b4c4-e33d08f8aa66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71cf-7574-b4c4-e33d08f8aa66",
        "storage_key": "property/6767906449166342/019d026b-71cf-7574-b4c4-e33d08f8aa66.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ0yNKLqQuokRt6Gzu6JIERQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_abcf773d-ab89-4797-be17-025f35ab1391",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health",
      "poi_address": "4261 E Little Creek Rd, Norfolk, VA 23518, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-b941-71c9-a623-a7849c886189.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-b941-71c9-a623-a7849c886189",
        "storage_key": "property/6767906449166342/019fce08-b941-71c9-a623-a7849c886189.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cvs.com/store-locator/norfolk-va-pharmacies/4261-e-little-creek-rd-norfolk-va-23518/storeid=6146?WT.mc_id=LS_GOOGLE_FS_6146",
      "poi_directions_map_url": "https://maps.google.com/?cid=13889949821512661681&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "36.9175767",
      "poi_longitude": "-76.19310589999999",
      "poi_miles_from_property": "8.9 mi",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 757-588-0123",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-71cf-7574-b4c4-e33d08f8aa66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71cf-7574-b4c4-e33d08f8aa66",
        "storage_key": "property/6767906449166342/019d026b-71cf-7574-b4c4-e33d08f8aa66.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj6quN0yRuokRsTpDQ8UDw8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_728aae81-793b-45fb-96dc-db587a6aeadd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health",
      "poi_address": "7525 Tidewater Dr #18, Norfolk, VA 23505, USA",
      "poi_short_description": "Clean space with cardio machines, strength-training gear, tanning beds, lockers, and showers. Wi-Fi. Friendly staff, clean lockers.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-e6cd-722b-aa44-fb4af3d13c72.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-e6cd-722b-aa44-fb4af3d13c72",
        "storage_key": "property/6767906449166342/019fce08-e6cd-722b-aa44-fb4af3d13c72.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=9540377635335859685&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "36.9145137",
      "poi_longitude": "-76.2569695",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 757-250-7332",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-71cf-7574-b4c4-e33d08f8aa66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71cf-7574-b4c4-e33d08f8aa66",
        "storage_key": "property/6767906449166342/019d026b-71cf-7574-b4c4-e33d08f8aa66.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBfCxoUyXuokR5W1Giek6ZoQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3d70f66c-2d2b-4fc5-afc0-c9f80e0a63be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Club Pilates",
      "poi_type": "Health",
      "poi_address": "1221 W 25th St Suite 502, Norfolk, VA 23508, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-eb94-77cf-a1b9-5b7d4ff11032.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-eb94-77cf-a1b9-5b7d4ff11032",
        "storage_key": "property/6767906449166342/019fce08-eb94-77cf-a1b9-5b7d4ff11032.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.clubpilates.com/norfolk/?utm_source=google.com&utm_medium=referral&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=1282086993381049553&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "club-pilates",
      "poi_latitude": "36.8754006",
      "poi_longitude": "-76.30302010000001",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 757-937-3020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-71c9-741d-a2e0-8337862e790b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71c9-741d-a2e0-8337862e790b",
        "storage_key": "property/6767906449166342/019d026b-71c9-741d-a2e0-8337862e790b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJn8hxIHCZuokR0USg41PjyhE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_388085b3-77b5-4224-8430-52d787d92dbd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "GUD Yoga",
      "poi_type": "Health",
      "poi_address": "4807 Colley Ave, Norfolk, VA 23508, USA",
      "poi_short_description": "Relaxed studio featuring yoga classes for all levels.",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.gudyoga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4583752408024853447&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gud-yoga",
      "poi_latitude": "36.8875244",
      "poi_longitude": "-76.2953595",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 757-524-5033",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-71c9-741d-a2e0-8337862e790b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71c9-741d-a2e0-8337862e790b",
        "storage_key": "property/6767906449166342/019d026b-71c9-741d-a2e0-8337862e790b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJfbZ1OkGZuokRx6upgofCnD8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d251acaa-a68a-47dd-8f85-15bb571d5719",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Breathe Yoga Center",
      "poi_type": "Health",
      "poi_address": "4005 Granby St, Norfolk, VA 23504, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14709689893972097292&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "breathe-yoga-center",
      "poi_latitude": "36.883358",
      "poi_longitude": "-76.2820099",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 757-226-7881",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-71cf-7574-b4c4-e33d08f8aa66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71cf-7574-b4c4-e33d08f8aa66",
        "storage_key": "property/6767906449166342/019d026b-71cf-7574-b4c4-e33d08f8aa66.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCUe5otKZuokRDDlc9gVRI8w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4cbeec71-98ff-4929-9a98-ca3ade4190ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Northside Park",
      "poi_type": "Outdoor Attractions",
      "poi_address": "8400 Tidewater Dr, Norfolk, VA 23505, USA",
      "poi_short_description": "This 62-acre recreation area has a skate park, an indoor pool, picnic shelters & kids' play areas.",
      "poi_long_description": "This 62-acre recreation area has a skate park, an indoor pool, picnic shelters & kids' play areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-ed19-772b-91db-8adf056d3986.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-ed19-772b-91db-8adf056d3986",
        "storage_key": "property/6767906449166342/019fce08-ed19-772b-91db-8adf056d3986.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://norfolk.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9938939561690472748&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northside-park",
      "poi_latitude": "36.92874219999999",
      "poi_longitude": "-76.2566989",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 757-441-5834",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-7dab-70be-a040-03c057e4ccb7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-7dab-70be-a040-03c057e4ccb7",
        "storage_key": "property/6767906449166342/019d026b-7dab-70be-a040-03c057e4ccb7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJISk1dLGQuokRLCGjYt807ok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2b057df9-0114-43eb-b9d4-b4c704d8d56d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Ocean View Beach Park",
      "poi_type": "Outdoor Attractions",
      "poi_address": "100 W Ocean View Ave, Norfolk, VA 23503, USA",
      "poi_short_description": "Acres of beach & lawn for various festivals plus boardwalk & \nmusic bandshell with dancing.",
      "poi_long_description": "Acres of beach & lawn for various festivals plus boardwalk & \nmusic bandshell with dancing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-ed9d-7678-82f5-b39af4fd1066.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-ed9d-7678-82f5-b39af4fd1066",
        "storage_key": "property/6767906449166342/019fce08-ed9d-7678-82f5-b39af4fd1066.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://oceanviewbeachpark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17084434943665190136&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ocean-view-beach-park",
      "poi_latitude": "36.9546116",
      "poi_longitude": "-76.25091069999999",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-7dab-70be-a040-03c057e4ccb7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-7dab-70be-a040-03c057e4ccb7",
        "storage_key": "property/6767906449166342/019d026b-7dab-70be-a040-03c057e4ccb7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQdx-U4yQuokR-DRvZRAbGO0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_12383ef4-6af8-456a-b7b6-b516b274a6bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Norfolk Botanical Garden",
      "poi_type": "Outdoor Attractions",
      "poi_address": "6700 Azalea Garden Rd, Norfolk, VA 23518, USA",
      "poi_short_description": "April azaleas are the showstoppers at this lush green space, which also features 450 rose varieties.",
      "poi_long_description": "April azaleas are the showstoppers at this lush green space, which also features 450 rose varieties.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-ee2e-71b8-9ee7-c937f5094c5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-ee2e-71b8-9ee7-c937f5094c5b",
        "storage_key": "property/6767906449166342/019fce08-ee2e-71b8-9ee7-c937f5094c5b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.norfolkbotanicalgarden.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8087862209354249196&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "norfolk-botanical-garden",
      "poi_latitude": "36.9013862",
      "poi_longitude": "-76.19998939999999",
      "poi_miles_from_property": "8.7 mi",
      "poi_walking_minutes": "3 hours 15 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 757-441-5830",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-7dab-70be-a040-03c057e4ccb7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-7dab-70be-a040-03c057e4ccb7",
        "storage_key": "property/6767906449166342/019d026b-7dab-70be-a040-03c057e4ccb7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJETolPM-WuokR7LPd_NPbPXA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ff18a37e-8419-41a4-bb7f-4eca140cd886",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Virginia Zoo",
      "poi_type": "Outdoor Attractions",
      "poi_address": "3500 Granby St, Norfolk, VA 23504, USA",
      "poi_short_description": "Sprawling park with 700+ animals from 150+ species, plus tours, gardens & kids' camps.",
      "poi_long_description": "Sprawling park with 700+ animals from 150+ species, plus tours, gardens & kids' camps.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-d7db-738c-a2e2-001be68b1592.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-d7db-738c-a2e2-001be68b1592",
        "storage_key": "property/6767906449166342/019fce08-d7db-738c-a2e2-001be68b1592.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.virginiazoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1690277800201406272&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "virginia-zoo",
      "poi_latitude": "36.8767691",
      "poi_longitude": "-76.2771229",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 757-441-2374",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-71cf-7574-b4c4-e33d08f8aa66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71cf-7574-b4c4-e33d08f8aa66",
        "storage_key": "property/6767906449166342/019d026b-71cf-7574-b4c4-e33d08f8aa66.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoXYXhiuYuokRQMe7LLQSdRc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_00c28b17-5626-4d02-aad7-2a629bd9f2fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Hermitage Museum & Gardens",
      "poi_type": "Outdoor Attractions",
      "poi_address": "7637 N Shore Rd, Norfolk, VA 23505, USA",
      "poi_short_description": "Historic home & picturesque gardens offering a fine art collection, professional program & classes.",
      "poi_long_description": "Historic home & picturesque gardens offering a fine art collection, professional program & classes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-f2be-730b-8132-4a228a5a6e0c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-f2be-730b-8132-4a228a5a6e0c",
        "storage_key": "property/6767906449166342/019fce08-f2be-730b-8132-4a228a5a6e0c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://thehermitagemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1270270731028078757&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hermitage-museum--gardens",
      "poi_latitude": "36.9103442",
      "poi_longitude": "-76.3132334",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 757-423-2052",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-77e0-70f1-93ff-6908a3594602.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-77e0-70f1-93ff-6908a3594602",
        "storage_key": "property/6767906449166342/019d026b-77e0-70f1-93ff-6908a3594602.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJRX9T556ZuokRpSCB63_ooBE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c9477494-ae2f-479c-a473-44e740c7fddd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Plum Point Park",
      "poi_type": "Outdoor Attractions",
      "poi_address": "Norfolk, VA 23507, USA",
      "poi_short_description": "Riverside open space with a dock for kayaks and canoes, plus paved paths and benches.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-f4ee-7538-bb02-344f2a3d11fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-f4ee-7538-bb02-344f2a3d11fe",
        "storage_key": "property/6767906449166342/019fce08-f4ee-7538-bb02-344f2a3d11fe.webp",
        "width": 1280,
        "height": 1068
      },
      "poi_business_url": "https://www.norfolk.gov/5380/Parks-and-Recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=13374563498234033307&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "plum-point-park",
      "poi_latitude": "36.8605354",
      "poi_longitude": "-76.30782339999999",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 757-823-4291",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-7dab-70be-a040-03c057e4ccb7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-7dab-70be-a040-03c057e4ccb7",
        "storage_key": "property/6767906449166342/019d026b-7dab-70be-a040-03c057e4ccb7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ50CsWmaYuokRmzQl4qP-m7k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1f35deba-c32f-43cd-b0c5-ac81d8309aaf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Town Point Park",
      "poi_type": "Outdoor Attractions",
      "poi_address": "113 Waterside Dr, Norfolk, VA 23510, USA",
      "poi_short_description": "Landscaped green space on the river with fountains, picnic areas, seasonal performances & festivals.",
      "poi_long_description": "Landscaped green space on the river with fountains, picnic areas, seasonal performances & festivals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-f4e0-750e-a96b-e5f9b773ec9d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-f4e0-750e-a96b-e5f9b773ec9d",
        "storage_key": "property/6767906449166342/019fce08-f4e0-750e-a96b-e5f9b773ec9d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://festevents.org/venues/town-point-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7201352007932728098&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "town-point-park",
      "poi_latitude": "36.8453265",
      "poi_longitude": "-76.2940234",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 757-441-2345",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-7dab-70be-a040-03c057e4ccb7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-7dab-70be-a040-03c057e4ccb7",
        "storage_key": "property/6767906449166342/019d026b-7dab-70be-a040-03c057e4ccb7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJXZz9rnSYuokRIlNgL39X8GM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6e036338-817f-4e8d-ae85-3dae36c4c554",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Fort Norfolk",
      "poi_type": "Outdoor Attractions",
      "poi_address": "801 Front St, Norfolk, VA 23510, USA",
      "poi_short_description": "Circa-1810 fort with multiple structures & a dungeon, open Jun–Sep for guided tours.",
      "poi_long_description": "Circa-1810 fort with multiple structures & a dungeon, open Jun–Sep for guided tours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-f5e0-70bb-9638-b7c4e79164c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-f5e0-70bb-9638-b7c4e79164c1",
        "storage_key": "property/6767906449166342/019fce08-f5e0-70bb-9638-b7c4e79164c1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.virginia.org/Listings/HistoricSites/FortNorfolk/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5252648829275457786&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-norfolk",
      "poi_latitude": "36.85677099999999",
      "poi_longitude": "-76.3063044",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 757-754-2004",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-71cf-7574-b4c4-e33d08f8aa66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71cf-7574-b4c4-e33d08f8aa66",
        "storage_key": "property/6767906449166342/019d026b-71cf-7574-b4c4-e33d08f8aa66.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxfoPdG-YuokR-sjVzkco5Ug",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_afac7bac-8afc-4181-81c8-8c93e80712b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Lafayette Park",
      "poi_type": "Outdoor Attractions",
      "poi_address": "3500 Granby St, Norfolk, VA 23504, USA",
      "poi_short_description": "This 32-acre park features a playground, picnic shelters & a boat ramp, plus basketball & baseball.",
      "poi_long_description": "This 32-acre park features a playground, picnic shelters & a boat ramp, plus basketball & baseball.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-f967-72f0-8454-64b66a5c222c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-f967-72f0-8454-64b66a5c222c",
        "storage_key": "property/6767906449166342/019fce08-f967-72f0-8454-64b66a5c222c.webp",
        "width": 1000,
        "height": 1000
      },
      "poi_business_url": "http://www.norfolk.gov/Facilities/Facility/Details/36",
      "poi_directions_map_url": "https://maps.google.com/?cid=11040299728726169162&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lafayette-park",
      "poi_latitude": "36.8784973",
      "poi_longitude": "-76.28125080000001",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 757-441-5834",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-7dab-70be-a040-03c057e4ccb7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-7dab-70be-a040-03c057e4ccb7",
        "storage_key": "property/6767906449166342/019d026b-7dab-70be-a040-03c057e4ccb7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJAxSmui2YuokRSpaQ-BsGN5k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b9484659-4622-4f6b-88ec-563f7f95207a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "The Glowline",
      "poi_type": "Outdoor Attractions",
      "poi_address": "1417 Azalea Ct, Norfolk, VA 23507, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-fbcd-76f8-a520-261cc97babd3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-fbcd-76f8-a520-261cc97babd3",
        "storage_key": "property/6767906449166342/019fce08-fbcd-76f8-a520-261cc97babd3.webp",
        "width": 1280,
        "height": 759
      },
      "poi_business_url": "http://www.elizabethrivertrail.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15368972411702064167&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-glowline",
      "poi_latitude": "36.8733965",
      "poi_longitude": "-76.3026814",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-7dab-70be-a040-03c057e4ccb7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-7dab-70be-a040-03c057e4ccb7",
        "storage_key": "property/6767906449166342/019d026b-7dab-70be-a040-03c057e4ccb7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJpWI4MXaZuokRJ7RH6vqOSdU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a38e9c27-08ff-4a44-af98-6b7ef9e1561a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "1530 Gilbert St",
      "poi_type": "Major Employers",
      "poi_address": "1530 Gilbert St, Norfolk, VA 23511, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1698530004174628094&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "1530-gilbert-st",
      "poi_latitude": "36.9484036",
      "poi_longitude": "-76.3090489",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-71cf-7574-b4c4-e33d08f8aa66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71cf-7574-b4c4-e33d08f8aa66",
        "storage_key": "property/6767906449166342/019d026b-71cf-7574-b4c4-e33d08f8aa66.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb8YqKjaauokR_uQrIwpkkhc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7cc67d9a-81d7-4d1d-953c-e676246165be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "NATO Allied Command Transformation",
      "poi_type": "Major Employers",
      "poi_address": "7857 Blandy Rd STE 100, Norfolk, VA 23551, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-fb05-704c-a763-224960c77c13.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-fb05-704c-a763-224960c77c13",
        "storage_key": "property/6767906449166342/019fce08-fb05-704c-a763-224960c77c13.webp",
        "width": 676,
        "height": 384
      },
      "poi_business_url": "https://www.act.nato.int/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10023685095306957935&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nato-allied-command-transformation",
      "poi_latitude": "36.921433",
      "poi_longitude": "-76.302356",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 757-747-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-71cf-7574-b4c4-e33d08f8aa66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71cf-7574-b4c4-e33d08f8aa66",
        "storage_key": "property/6767906449166342/019d026b-71cf-7574-b4c4-e33d08f8aa66.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ52Ln1I6ZuokRbxQmhnxIG4s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_894dfe7d-d79c-4533-a5d1-b52904bd59ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Sentara Health",
      "poi_type": "Major Employers",
      "poi_address": "6015 Poplar Hall Dr, Norfolk, VA 23502, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-fcf8-7380-a3d5-cf2a97adb3d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-fcf8-7380-a3d5-cf2a97adb3d6",
        "storage_key": "property/6767906449166342/019fce08-fcf8-7380-a3d5-cf2a97adb3d6.webp",
        "width": 734,
        "height": 488
      },
      "poi_business_url": "https://www.sentara.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10665071979920095753&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sentara-health",
      "poi_latitude": "36.8506128",
      "poi_longitude": "-76.19711280000001",
      "poi_miles_from_property": "11.1 mi",
      "poi_walking_minutes": "4 hours 10 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 757-455-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-71cf-7574-b4c4-e33d08f8aa66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71cf-7574-b4c4-e33d08f8aa66",
        "storage_key": "property/6767906449166342/019d026b-71cf-7574-b4c4-e33d08f8aa66.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOaFaTD6WuokRCfobs3XyAZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3c5ec779-6610-47fc-89ac-4313942093eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Sentara Norfolk General Hospital",
      "poi_type": "Major Employers",
      "poi_address": "600 Gresham Dr, Norfolk, VA 23507, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-e022-7119-af3a-5c2d91736a4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-e022-7119-af3a-5c2d91736a4e",
        "storage_key": "property/6767906449166342/019fce08-e022-7119-af3a-5c2d91736a4e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.sentara.com/hospitalslocations/sentara-norfolk-general-hospital/directions-parking",
      "poi_directions_map_url": "https://maps.google.com/?cid=3954889307129810351&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sentara-norfolk-general-hospital",
      "poi_latitude": "36.8623012",
      "poi_longitude": "-76.3032334",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 757-388-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-779a-777e-9f08-6f8ee7cc1cdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-779a-777e-9f08-6f8ee7cc1cdb",
        "storage_key": "property/6767906449166342/019d026b-779a-777e-9f08-6f8ee7cc1cdb.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJnUEuMGiYuokRr4129d6W4jY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9bbc16e8-2c1e-4952-bdd4-0820b27c9f61",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Children's Hospital of The King's Daughters",
      "poi_type": "Major Employers",
      "poi_address": "601 Childrens Ln, Norfolk, VA 23507, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-ff64-7518-8d2c-141cfb60063b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-ff64-7518-8d2c-141cfb60063b",
        "storage_key": "property/6767906449166342/019fce08-ff64-7518-8d2c-141cfb60063b.webp",
        "width": 1060,
        "height": 596
      },
      "poi_business_url": "https://www.chkd.org/locations/chkd-main-hospital-emergency-center?utm_source=local-listing&utm_medium=organic&utm_campaign=website-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=4055598881103474643&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-hospital-of-the-kings-daughters",
      "poi_latitude": "36.8626168",
      "poi_longitude": "-76.3017886",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 757-668-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-779a-777e-9f08-6f8ee7cc1cdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-779a-777e-9f08-6f8ee7cc1cdb",
        "storage_key": "property/6767906449166342/019d026b-779a-777e-9f08-6f8ee7cc1cdb.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJaRp_uGmYuokR0--k47FhSDg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ec56d56a-2d77-4e37-9637-d976e80d2a03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Eastern Virginia Medical School",
      "poi_type": "Major Employers",
      "poi_address": "825 Fairfax Ave, Norfolk, VA 23507, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce09-01ef-7690-bb23-1e03745dd6fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-01ef-7690-bb23-1e03745dd6fe",
        "storage_key": "property/6767906449166342/019fce09-01ef-7690-bb23-1e03745dd6fe.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.evms.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15570955254717829078&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eastern-virginia-medical-school",
      "poi_latitude": "36.8604506",
      "poi_longitude": "-76.3035708",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 757-446-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-71c9-741d-a2e0-8337862e790b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71c9-741d-a2e0-8337862e790b",
        "storage_key": "property/6767906449166342/019d026b-71c9-741d-a2e0-8337862e790b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJK0K5kmiYuokR1k_1Qk4lF9g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d6d93092-7f12-4837-8a8a-34f972d3ae10",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Old Dominion University",
      "poi_type": "Major Employers",
      "poi_address": "5115 Hampton Blvd, Norfolk, VA 23529, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce09-02bd-72bc-815e-11eeae885506.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-02bd-72bc-815e-11eeae885506",
        "storage_key": "property/6767906449166342/019fce09-02bd-72bc-815e-11eeae885506.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.odu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14784152382838033324&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-dominion-university",
      "poi_latitude": "36.8853217",
      "poi_longitude": "-76.3058786",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 757-683-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-71c9-741d-a2e0-8337862e790b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71c9-741d-a2e0-8337862e790b",
        "storage_key": "property/6767906449166342/019d026b-71c9-741d-a2e0-8337862e790b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJRTm6JK2ZuokRrEtOLEPcK80",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9b278976-0a44-4a30-a5bf-86c1167b207b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Norfolk State University",
      "poi_type": "Major Employers",
      "poi_address": "700 Park Ave, Norfolk, VA 23504, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce09-0354-73e5-82f4-98123a3f6df3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-0354-73e5-82f4-98123a3f6df3",
        "storage_key": "property/6767906449166342/019fce09-0354-73e5-82f4-98123a3f6df3.webp",
        "width": 1280,
        "height": 555
      },
      "poi_business_url": "https://www.nsu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6371895038292133084&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "norfolk-state-university",
      "poi_latitude": "36.8479292",
      "poi_longitude": "-76.2620987",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 757-823-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-71c9-741d-a2e0-8337862e790b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71c9-741d-a2e0-8337862e790b",
        "storage_key": "property/6767906449166342/019d026b-71c9-741d-a2e0-8337862e790b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJU7KMgfCXuokR3AR6D8eEbVg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_63f02dde-6003-4302-9c89-e548c9c2ffc6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Tidewater Community College - Norfolk Campus",
      "poi_type": "Major Employers",
      "poi_address": "300 Granby St, Norfolk, VA 23510, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-d12a-7288-9112-96d01b7cd31c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce08-d12a-7288-9112-96d01b7cd31c",
        "storage_key": "property/6767906449166342/019fce08-d12a-7288-9112-96d01b7cd31c.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "https://www.tcc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14634708013926114657&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tidewater-community-college---norfolk-campus",
      "poi_latitude": "36.849878",
      "poi_longitude": "-76.2902944",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 757-822-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-71c9-741d-a2e0-8337862e790b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-71c9-741d-a2e0-8337862e790b",
        "storage_key": "property/6767906449166342/019d026b-71c9-741d-a2e0-8337862e790b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQ5zyvg2YuokRYeWgkWbtGMs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_130387c9-df3e-4ccc-8ef9-67f613d75ac8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "poi_name": "Naval Medical Center Portsmouth",
      "poi_type": "Major Employers",
      "poi_address": "620 John Paul Jones Cir, Portsmouth, VA 23708, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce09-0600-7339-b040-e50b79d1a608.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce09-0600-7339-b040-e50b79d1a608",
        "storage_key": "property/6767906449166342/019fce09-0600-7339-b040-e50b79d1a608.webp",
        "width": 1280,
        "height": 597
      },
      "poi_business_url": "https://portsmouth.tricare.mil/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4171512084572656565&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "naval-medical-center-portsmouth",
      "poi_latitude": "36.844072",
      "poi_longitude": "-76.30480399999999",
      "poi_miles_from_property": "9.0 mi",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 757-953-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-779a-777e-9f08-6f8ee7cc1cdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026b-779a-777e-9f08-6f8ee7cc1cdb",
        "storage_key": "property/6767906449166342/019d026b-779a-777e-9f08-6f8ee7cc1cdb.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0Zgmq3mYuokRtdMzqSMw5Dk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "custom_69647d92-c9f7-432d-af6a-dcd0e3fa697b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_280cb25a-a7b8-46cc-846a-3808010a321d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_79ce8684-88e3-4ce0-b334-de3e58ccce56",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_1e52ccb8-b93d-44eb-97fb-253bb620c873",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_151391e5-62ab-4d55-aa77-2edac078ade3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_6c6cf3dd-da27-4f28-adb4-bcbfc64fc9ea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "16:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_74f87757f4f16b15f60e6abc",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "rating": "4",
      "name": "false",
      "text": "I have lived at this complex for a total of two years and am very pleased with my experience. \nThe office staff is very polite, helpful, and quick to respond to an email. \nThe on call maintenance crew is also a plus and we're very quick to come out and assist with any replacements that were necessary. \nYou get a great deal of room for the price ( ask about student/military discount) and the location is 5 min from base and 15 from ODU. \nOne star off because the apartments are somewhat dated with older kitchen appliances and water heaters.",
      "date": "false",
      "title": "Great location, helpful staff"
    },
    {
      "id": "ec_941116d9d12ef85074a82210",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "rating": "5",
      "name": "false",
      "text": "I actually found this apartment using apartments.com and I love it ! From the tennis courts to the pool and the quiet gated neighborhood this has made my very own first apartment a wonderful experience .",
      "date": "false",
      "title": "I love it !"
    },
    {
      "id": "ec_39ed5603d3fa71810e981208",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "rating": "4",
      "name": "false",
      "text": "Neighbors are loud at times but the apartments are really nice. Some even come furnished.",
      "date": "false",
      "title": "Good"
    },
    {
      "id": "ec_5bd102be06825aa107316b53",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "rating": "4",
      "name": "false",
      "text": "Breezy Point has great discounts for students and military. Also in close proximity of restaurants. The staff has always been nice to me since day 1. I've been living here since June 2014, I haven't really had any major problems with my apartment and if you stay on maintenance they will get what you need fixed the same day most of the time.",
      "date": "false",
      "title": "Good discounts"
    },
    {
      "id": "ec_fb0b1da850e18da7f28b7974",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "rating": "5",
      "name": "false",
      "text": "I been here three months now and no complaints I love my unit and the area, it's very quiet here and neighbors are friendly, I definitely recommend everyone check this place out.",
      "date": "false",
      "title": "I love it"
    },
    {
      "id": "ec_0833e947edc9330aecb472df",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "rating": "5",
      "name": "false",
      "text": "Firstly, I’ve never took the time to comment or write my own review but I do read them. It’s the world we live in....With that said, I feel compelled to share my experience. \n \nThe Arlay Point apartments are nice!  The staff was very informative, professional, and genuine people.  \n\nBrianna was amazing, super calm, kind and knowledgeable in her job and about the properties.  Morgan was that way as well, we had kids in tow, she provided them with crayons, attention and small talk. I also recall a grounds worker Mimi who greeted us with pleasantry’s as we entered the office. The staff’s vibe is good at Arlay Pointe! That speaks volumes about a company to me.  I’m glad we found this community for my daughter and lucky they had apartment availability. If you are looking for a place, you must put this high on your list and make a visit soon.",
      "date": "false",
      "title": "Good Community...Professional staff"
    },
    {
      "id": "ec_809aa5b971439cc6103da348",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "rating": "5",
      "name": "false",
      "text": "I’ve lived here for 4 years and there has been a lot of changes since the new company has taken over. The older owners would never fix anything and there was always water leaking, bugs, no where to park, and crime. Since the new owners, the overall property is cleaner and the amenities are expanding. The pool makeover has been incredible and I really like that they do bbqs for us on Sunday.\n\nThe front office is really, really nice. Stanley and Bernadette are always smiling and helpful. Ms. Shirley has been here a long time and always gives you tips for the community. The managers, Morgan and Brianna really work hard to make the community cleaner and safer and they always address any concerns I’ve had quickly. Mr. Melvin in maintenance is really awesome too. I would recommend living here to anyone.",
      "date": "false",
      "title": "Welcome changes "
    },
    {
      "id": "ec_6fd6f8887bb5d3104deb9776",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "rating": "5",
      "name": "false",
      "text": "I know this last year was horribly tough, and for these guys it's been even tougher having to switch management. Anna, Shirley, Stanley, and Artavius are making strides to make the complex the best it can be. ",
      "date": "false",
      "title": "Keep it up"
    },
    {
      "id": "ec_bc2c02e6a910e30d084a03ca",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "rating": "4",
      "name": "false",
      "text": "if you're a college student or living on your own for the first time this is a great place to start. grew up in the nicer part of Williamsburg, moved here in august of 2020 for school. It had some questionable reviews however It's been a great experience thus far. The staff are fairly helpful if you keep up with your rent. There are plenty of stores and outlets within a mile of the complex. I've seen the occasional fly or \n small spider here and there but nothing too serious. there  are washer and dryers in the building you live in that you will share with your neighbors.  the walls are pretty good at blocking out noise, the appliances have always worked and other than a slight hiccup with the bathroom fan its been no complaints from me on that. my neighbors are friendly and  everyone minds their own business. the only problems I've noticed are that due to the low altitude the units located closer to the fence are prone to flooding. overall for the money its not a bad spot especially in Norfolk. would recommend for ODU students and military personnel as there are plenty over here. good luck",
      "date": "false",
      "title": "Great spot for a first time renter"
    },
    {
      "id": "ec_3f635e9a43ada977b6383de8",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "rating": "5",
      "name": "false",
      "text": "I was in town two weeks ago with my son who will be attending ODU and we stopped by a few apartment communities in the area. We stopped by this place to get some information. Even though we couldn’t get exact pricing because my son will be starting in January 2027; Hendrya was very helpful and kind. I like this place, its amenities, and close proximity to the campus. Thank you Hendrya!",
      "date": "false",
      "title": "Must See"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_e4062a56-1578-440a-8475-92c52b55d6bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-8cf3-7321-bfdf-7ae5d8c9047a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fce08-8cf3-7321-bfdf-7ae5d8c9047a",
        "storage_key": "property/6767906449166342/019fce08-8cf3-7321-bfdf-7ae5d8c9047a.webp",
        "width": 984,
        "height": 656
      },
      "virtual_tour_title": "Renovated 1 BR, 1 BA - 675 SF",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ZLjfKiPFveh&play=1"
    },
    {
      "id": "custom_d1912374-d122-4002-a4f0-7a6527b91e05",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-8cb8-77d8-8572-11811950a5dc.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fce08-8cb8-77d8-8572-11811950a5dc",
        "storage_key": "property/6767906449166342/019fce08-8cb8-77d8-8572-11811950a5dc.webp",
        "width": 1920,
        "height": 1280
      },
      "virtual_tour_title": "Renovated 2 BR, 1 BA - 965 SF",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=oJpoJznGTsj&play=1"
    },
    {
      "id": "custom_4a8a70f2-2360-4819-a184-aa7c887786e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-92ac-71db-ad23-b4843d397964.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fce08-92ac-71db-ad23-b4843d397964",
        "storage_key": "property/6767906449166342/019fce08-92ac-71db-ad23-b4843d397964.webp",
        "width": 984,
        "height": 554
      },
      "virtual_tour_title": "Oak 2 BR, 1 BA - 965 SF",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=T2AGDq3UBRo&play=1"
    },
    {
      "id": "custom_eeaa4896-e5ed-4889-be3c-58f7e7f96b6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-930f-70ec-bfea-7ddab5d8d93b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fce08-930f-70ec-bfea-7ddab5d8d93b",
        "storage_key": "property/6767906449166342/019fce08-930f-70ec-bfea-7ddab5d8d93b.webp",
        "width": 984,
        "height": 656
      },
      "virtual_tour_title": "Classic 2 BR, 1 BA - 965 SF",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=oBNdZWSbcbH&play=1"
    },
    {
      "id": "custom_2e108c09-4b13-47b1-b7e0-6006e55ec76c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-98bf-72da-97b5-eca02141a3af.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fce08-98bf-72da-97b5-eca02141a3af",
        "storage_key": "property/6767906449166342/019fce08-98bf-72da-97b5-eca02141a3af.webp",
        "width": 984,
        "height": 656
      },
      "virtual_tour_title": "Community Amenities",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=6843b6955c1fea608f1e7e0b"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_5c71d972cbc9f696def703c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "engrain",
      "external_id": "396335",
      "name": "Application Fee",
      "description": "Per applicant.",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_a8056080527c80d16673d664",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "engrain",
      "external_id": "396336",
      "name": "Security Deposit",
      "description": "Deposit amount applies with approved credit and may be higher for conditional approvals.",
      "amount": 750,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": true,
      "is_taxable": false
    },
    {
      "id": "ec_e46459ff8c91db7bd5eefc01",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "engrain",
      "external_id": "396339",
      "name": "Reservation Fee",
      "description": "false",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_57497361165b1df047afeda3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "engrain",
      "external_id": "396340",
      "name": "Month To Month Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_ca6115274a80feded3414ad0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "engrain",
      "external_id": "396341",
      "name": "Pet Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "350.00 / 150.00",
      "amount_type": "text",
      "timing": "One-time, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_c3a2b62e268eecffecce21e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "engrain",
      "external_id": "396342",
      "name": "Pet Rent",
      "description": "false",
      "amount": 55,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_44b90c5885b3e0d43bd02afe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "engrain",
      "external_id": "396343",
      "name": "Transfer Fee",
      "description": "Transfer fee is 50% of rent; minimum $500",
      "amount": 500,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_1e023988db5b2f54ebe24128",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "engrain",
      "external_id": "396344",
      "name": "Reserved Parking Space",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "parking",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_e613309a1b72e880e13edc7f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "engrain",
      "external_id": "564939",
      "name": "Utility - Electric Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_d62417e6e80f5899b4c2c3a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "engrain",
      "external_id": "564940",
      "name": "Utility - Water/Sewer Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_8668bfd212ae43ff0c321343",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "engrain",
      "external_id": "564946",
      "name": "Utility - New Account Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_d661e69b691c5655916d3247",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "engrain",
      "external_id": "835104",
      "name": "Buy-Out Fee",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "One Month's Rent",
      "amount_type": "text",
      "timing": "One-time",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_cfcfe6df2073cc3786303704",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "engrain",
      "external_id": "835105",
      "name": "NSF/Returned Check Fee",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_3e54b394cb39668ed9da2c10",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "engrain",
      "external_id": "835110",
      "name": "Washer/Dryer Fee",
      "description": "false",
      "amount": 60,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "community",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_c112d87a53d106b73641978d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "engrain",
      "external_id": "835112",
      "name": "Parking - Unreserved",
      "description": "false",
      "amount": 25,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "parking",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_55c592dddecc80ffc598d18a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "engrain",
      "external_id": "835118",
      "name": "Late Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per occurrence",
      "category": "penalties",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a1322-4169-718d-99d5-7a8f13cb9274",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "aion-reserves-at-tidewater-auto",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342"
    },
    {
      "lead_collector_id": "019c3043-926e-769a-91b3-8011a7ed6d97",
      "lead_source": "FACEBOOK_ADS",
      "name": "reserves-at-tidewater",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342"
    },
    {
      "lead_collector_id": "019c3043-92dd-7024-8662-5d34c54d2ba2",
      "lead_source": "LANDING_PAGE",
      "name": "reserves-at-tidewater",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "page_item_url": "dog-park-apartments-norfolk-va-tidewater-891",
      "search_query": "dog park apartments in Norfolk, VA",
      "category": "Amenity",
      "h1_title": "Explore Dog Park Apartments in Norfolk, VA",
      "h2_subtitle": "Discover apartments with dog park access in Norfolk, VA. Reserves at Tidewater offers a community where pets are welcomed with open paws.",
      "page_copy": "Searching for dog park apartments in Norfolk, VA? Look no further than Reserves at Tidewater, where both you and your furry friends will feel right at home. Our community boasts a fantastic dog park, offering a perfect space for dogs to run and play. This feature, combined with our other exceptional amenities like a fitness center and swimming pool, ensures that all residents and their pets enjoy a vibrant lifestyle.\n\nLocated in the heart of Norfolk, Reserves at Tidewater offers spacious one- and two-bedroom floor plans ideal for pet owners. Our modern interiors and private balconies create a welcoming environment, while our commitment to pet-friendly amenities sets us apart. Enjoy a leisurely stroll to the nearby Glenwood Park neighborhood or spend the day in our dedicated picnic area. Experience the joy of finding a home that accommodates all your family members, both human and canine.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with mature trees in front.",
        "public_id": "01a015db-5ab7-736e-b281-cae542531f2e",
        "storage_key": "property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in Norfolk, VA",
      "seo_description": "Discover pet-friendly living at Reserves at Tidewater, featuring a dedicated dog park in Norfolk, VA. Perfect for pet owners seeking vibrant community life.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "page_item_url": "apartments-swimming-pool-norfolk-city-tidewater-1",
      "search_query": "apartments with swimming pool Norfolk City",
      "category": "Amenity",
      "h1_title": "Apartments with Swimming Pool in Norfolk City",
      "h2_subtitle": "Experience the best of Norfolk City living with a swimming pool. Reserves at Tidewater offers refreshing amenities and comfortable living spaces.",
      "page_copy": "Looking for apartments with a swimming pool in Norfolk City? Reserves at Tidewater is your ideal choice for a vibrant and enjoyable lifestyle. Immerse yourself in relaxation and fun with our luxurious swimming pool, perfect for cooling off on hot Virginia days or socializing with neighbors.\n\nOur spacious one- and two-bedroom floor plans ensure comfort and style, complete with modern kitchens and private balconies. Alongside our pool, residents enjoy a state-of-the-art fitness center and a dog park, creating a well-rounded community experience. Positioned in the bustling Norfolk City, and close to the charming Glenwood Park neighborhood, you have everything you need right at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with mature trees in front.",
        "public_id": "01a015db-5ab7-736e-b281-cae542531f2e",
        "storage_key": "property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Swimming Pool Norfolk City",
      "seo_description": "Find the perfect apartments in Norfolk City with a swimming pool at Reserves at Tidewater. Enjoy modern amenities and a lively community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-glenwood-park-tidewater-70",
      "search_query": "pet friendly apartments Glenwood Park",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Glenwood Park",
      "h2_subtitle": "Discover pet-friendly apartments in Glenwood Park at Reserves at Tidewater. Where pets enjoy a welcoming and comfortable community lifestyle.",
      "page_copy": "If you're searching for pet-friendly apartments in Glenwood Park, Reserves at Tidewater is a haven for pet owners and their furry companions. Our community is designed to make life comfortable and enjoyable for all residents, offering a fantastic dog park and ample outdoor spaces for your pets to explore.\n\nLocated adjacent to Norfolk's Glenwood Park neighborhood, our one- and two-bedroom apartments are ideal for pet lovers seeking modern living spaces. Enjoy amenities like a fitness center, swimming pool, and private balconies, which provide both relaxation and recreation. Pet-friendly features ensure that all family members, including the four-legged ones, are happy and cared for.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with mature trees in front.",
        "public_id": "01a015db-5ab7-736e-b281-cae542531f2e",
        "storage_key": "property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments Glenwood Park",
      "seo_description": "Reserves at Tidewater offers pet-friendly apartments near Glenwood Park with excellent amenities and a dedicated dog park. Perfect for pet owners!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "page_item_url": "norfolk-apartments-with-air-conditioning-tidewater-475",
      "search_query": "Norfolk apartments with air conditioning",
      "category": "Amenity",
      "h1_title": "Norfolk Apartments with Air Conditioning",
      "h2_subtitle": "Stay cool at Reserves at Tidewater, offering Norfolk apartments with air conditioning. Enjoy modern comforts in every home.",
      "page_copy": "Searching for Norfolk apartments with air conditioning? At Reserves at Tidewater, comfort is a top priority for all our residents. Our spacious one- and two-bedroom floor plans come equipped with modern amenities, including efficient air conditioning, to provide a pleasant living experience year-round.\n\nBeyond air-conditioned interiors, residents can unwind by our swimming pool or workout in the fully-equipped fitness center. Situated near the charming Glenwood Park area, our community in Norfolk also features pet-friendly amenities, such as a dog park, ensuring both you and your pets are comfortably accommodated. Discover the joy of living in a community that embraces comfort and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with mature trees in front.",
        "public_id": "01a015db-5ab7-736e-b281-cae542531f2e",
        "storage_key": "property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Norfolk Apartments with Air Conditioning",
      "seo_description": "Find Norfolk apartments with air conditioning at Reserves at Tidewater. Experience cool comfort with top amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "page_item_url": "in-unit-dishwasher-norfolk-va-apartments-tidewater-433",
      "search_query": "in unit dishwasher Norfolk, VA apartments",
      "category": "Amenity",
      "h1_title": "Norfolk, VA Apartments with In-Unit Dishwasher",
      "h2_subtitle": "Discover Norfolk, VA apartments featuring in-unit dishwashers at Reserves at Tidewater. Modern living made easy and convenient.",
      "page_copy": "Looking for Norfolk, VA apartments with an in-unit dishwasher? Reserves at Tidewater offers modern living with all the amenities you need for a hassle-free lifestyle. Each one- and two-bedroom apartment boasts a contemporary kitchen, complete with an in-unit dishwasher, making meal cleanup a breeze.\n\nLocated conveniently near Glenwood Park, our community provides more than just well-equipped kitchens. Enjoy additional amenities such as a fitness center, refreshing swimming pool, and pet-friendly spaces including a dog park. At Reserves at Tidewater, embrace a comfortable and convenient living experience in the heart of Norfolk, VA.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with mature trees in front.",
        "public_id": "01a015db-5ab7-736e-b281-cae542531f2e",
        "storage_key": "property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Norfolk, VA Apartments with In-Unit Dishwasher",
      "seo_description": "Find Norfolk, VA apartments with an in-unit dishwasher at Reserves at Tidewater. Enjoy modern amenities and convenience in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-norfolk-va-tidewater-124",
      "search_query": "one bedroom apartments norfolk va",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Norfolk, VA",
      "h2_subtitle": "Explore one bedroom apartments in Norfolk, VA at Reserves at Tidewater. Experience modern living in a vibrant community.",
      "page_copy": "Searching for one bedroom apartments in Norfolk, VA? Look no further than Reserves at Tidewater, where comfort and style meet in our thoughtfully designed floor plans. Each one-bedroom apartment features modern kitchens, perfect for today’s discerning residents, and is complemented by private balconies that offer a personal escape.\n\nNestled near Glenwood Park, our community provides easy access to an array of amenities designed for active lifestyles. Unwind by the swimming pool, break a sweat in the fitness center, or enjoy outdoor activities in our well-maintained common areas. Discover the perfect blend of convenience and modern living at Reserves at Tidewater.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with mature trees in front.",
        "public_id": "01a015db-5ab7-736e-b281-cae542531f2e",
        "storage_key": "property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Norfolk, VA",
      "seo_description": "Explore modern one bedroom apartments in Norfolk, VA at Reserves at Tidewater. Enjoy top-notch amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-glenwood-park-tidewater-254",
      "search_query": "two bedroom apartments in glenwood park",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Glenwood Park",
      "h2_subtitle": "Find spacious two bedroom apartments in the charming Glenwood Park area at Reserves at Tidewater. Ideal for comfortable living.",
      "page_copy": "Searching for two bedroom apartments in Glenwood Park? Located in the vibrant Norfolk, VA area, Reserves at Tidewater offers spacious two-bedroom layouts perfectly designed for comfort and functionality. Each apartment is equipped with a modern kitchen and private balcony, providing the perfect retreat after a long day.\n\nIn addition to our stylish interiors, residents can enjoy a range of amenities including a fitness center, a refreshing swimming pool, and pet-friendly spaces like our dog park. Situated near the lovely Glenwood Park, Reserves at Tidewater ensures that you have everything you need to enjoy a well-rounded lifestyle, all within your reach.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with mature trees in front.",
        "public_id": "01a015db-5ab7-736e-b281-cae542531f2e",
        "storage_key": "property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Glenwood Park",
      "seo_description": "Discover two bedroom apartments at Reserves at Tidewater in Glenwood Park. Enjoy spacious living with great amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "page_item_url": "apartments-near-granby-high-school-norfolk-tidewater-84",
      "search_query": "apartments near Granby High School Norfolk",
      "category": "School",
      "h1_title": "Apartments Near Granby High School, Norfolk",
      "h2_subtitle": "Discover apartments near Granby High School in Norfolk at Reserves at Tidewater. Enjoy modern amenities in an ideal location.",
      "page_copy": "Looking for apartments near Granby High School in Norfolk? Reserves at Tidewater offers the perfect blend of convenience and comfort. Our community is just a short drive from Granby High, making it a great choice for families and professionals alike. Choose from our spacious one- and two-bedroom apartments, designed with modern features and private balconies.\n\nResidents at Reserves at Tidewater enjoy a host of amenities, including a fitness center, a swimming pool, and a dog park, ensuring there's always something to do. Located in the vibrant neighborhood of Norfolk, VA, and close to Glenwood Park, our community is ideally situated for those looking to enjoy both convenience and a rich, active lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with mature trees in front.",
        "public_id": "01a015db-5ab7-736e-b281-cae542531f2e",
        "storage_key": "property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Granby High School, Norfolk",
      "seo_description": "Find modern apartments near Granby High School in Norfolk at Reserves at Tidewater. Experience convenient living with top amenities nearby.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "page_item_url": "apartments-near-granby-elementary-norfolk-tidewater-519",
      "search_query": "apartments close to Granby Elementary School Norfolk",
      "category": "School",
      "h1_title": "Apartments Near Granby Elementary School",
      "h2_subtitle": "Explore apartments close to Granby Elementary School in Norfolk at Reserves at Tidewater. Enjoy a family-friendly community.",
      "page_copy": "If you're searching for apartments close to Granby Elementary School in Norfolk, Reserves at Tidewater is the ideal choice. Situated conveniently near this top-rated school, our community offers spacious one- and two-bedroom floor plans with modern kitchens and private balconies, perfect for family living.\n\nIn addition to our comfortable apartments, Reserves at Tidewater features amenities that cater to all ages. From a sparkling swimming pool and fitness center to a dog park and picnic area, there's something for everyone. Nestled near Glenwood Park, our community provides a peaceful retreat with easy access to local attractions and conveniences, making it a great place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with mature trees in front.",
        "public_id": "01a015db-5ab7-736e-b281-cae542531f2e",
        "storage_key": "property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Granby Elementary School",
      "seo_description": "Discover family-friendly apartments near Granby Elementary School at Reserves at Tidewater in Norfolk. Spacious living with top amenities await.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "page_item_url": "glenwood-park-apartments-near-camp-allen-elementary-926",
      "search_query": "Glenwood Park apartments near Camp Allen Elementary",
      "category": "School",
      "h1_title": "Glenwood Park Apartments by Camp Allen Elementary",
      "h2_subtitle": "Find Glenwood Park apartments conveniently near Camp Allen Elementary. Enjoy a welcoming community at Reserves at Tidewater.",
      "page_copy": "Seeking Glenwood Park apartments near Camp Allen Elementary? Reserves at Tidewater offers a perfect location for families looking to stay close to educational facilities. Our community in Norfolk, VA, boasts spacious one- and two-bedroom apartments featuring contemporary kitchens and relaxing private balconies.\n\nBeyond our thoughtfully designed interiors, Reserves at Tidewater provides residents with a variety of amenities like a fitness center, swimming pool, and a dog park. Join this vibrant community near Glenwood Park, where families can enjoy both convenient proximity to Camp Allen Elementary and a neighborhood full of activities and serene spaces.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with mature trees in front.",
        "public_id": "01a015db-5ab7-736e-b281-cae542531f2e",
        "storage_key": "property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Glenwood Park Apartments by Camp Allen",
      "seo_description": "Discover Glenwood Park apartments near Camp Allen Elementary at Reserves at Tidewater. Ideal location with great amenities awaits.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "page_item_url": "norfolk-va-apartments-near-sewells-point-elementary-962",
      "search_query": "Norfolk VA apartments near Sewells Point Elementary",
      "category": "School",
      "h1_title": "Norfolk Apartments Near Sewells Point Elementary",
      "h2_subtitle": "Explore Norfolk, VA apartments conveniently located close to Sewells Point Elementary. Reserves at Tidewater offers family-friendly living.",
      "page_copy": "For families searching for Norfolk, VA apartments near Sewells Point Elementary, Reserves at Tidewater provides the perfect setting. Our community offers stylish one- and two-bedroom apartments with modern amenities, including upgraded kitchens and private balconies designed for comfortable living.\n\nReserves at Tidewater also features family-friendly amenities such as a sparkling swimming pool, a fully-equipped fitness center, and an on-site dog park. Nestled in the peaceful Glenwood Park neighborhood, this community is conveniently located and ideal for those who prioritize proximity to schools and vibrant community living. Schedule a tour today to discover all that our apartments have to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with mature trees in front.",
        "public_id": "01a015db-5ab7-736e-b281-cae542531f2e",
        "storage_key": "property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Norfolk Apts Near Sewells Point Elementary",
      "seo_description": "Find Norfolk VA apartments near Sewells Point Elementary at Reserves at Tidewater. Experience comfortable living with top amenities and convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "page_item_url": "apartments-near-suburban-park-elementary-23505-712",
      "search_query": "apartments near Suburban Park Elementary School 23505",
      "category": "School",
      "h1_title": "Apartments Near Suburban Park Elementary",
      "h2_subtitle": "Discover apartments near Suburban Park Elementary School in the 23505 area. Reserves at Tidewater offers ideal family living.",
      "page_copy": "Looking for apartments near Suburban Park Elementary School in the 23505 ZIP code? Reserves at Tidewater provides the perfect setting for families. Nestled in Norfolk's Glenwood Park neighborhood, our community offers spacious one- and two-bedroom floor plans with modern touches such as upgraded kitchens and private balconies.\n\nOur residents enjoy a variety of community amenities that cater to all lifestyles, including a fitness center, a sparkling swimming pool, and a dog park. Living at Reserves at Tidewater means being part of a vibrant community with convenient access to local schools like Suburban Park Elementary School, making it an ideal choice for families prioritizing education and lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with mature trees in front.",
        "public_id": "01a015db-5ab7-736e-b281-cae542531f2e",
        "storage_key": "property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Suburban Park Elementary Norfolk",
      "seo_description": "Explore Norfolk apartments near Suburban Park Elementary School at Reserves at Tidewater. Enjoy family-friendly living in the heart of the 23505 area.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "page_item_url": "apartments-close-to-norfolk-collegiate-va-578",
      "search_query": "apartments close to Norfolk Collegiate VA",
      "category": "School",
      "h1_title": "Apartments Close to Norfolk Collegiate, VA",
      "h2_subtitle": "Find apartments near Norfolk Collegiate in VA. Discover the vibrant lifestyle at Reserves at Tidewater, perfect for families and students.",
      "page_copy": "If you're looking for apartments close to Norfolk Collegiate in VA, consider Reserves at Tidewater. Our community, located in the scenic Glenwood Park area of Norfolk, offers spacious one- and two-bedroom apartments with features like upgraded kitchens and private balconies — ideal for both students and families seeking proximity to educational institutions.\n\nThe Reserves at Tidewater is not just about convenience; it's about lifestyle. Enjoy access to amenities such as a welcoming fitness center, a sparkling swimming pool, and a pet-friendly dog park. These features make our community the perfect blend of comfort and convenience, all while being just a short distance from Norfolk Collegiate. Come explore our apartments and see why we are a top choice for local living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with mature trees in front.",
        "public_id": "01a015db-5ab7-736e-b281-cae542531f2e",
        "storage_key": "property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Norfolk Collegiate VA",
      "seo_description": "Discover apartments close to Norfolk Collegiate at Reserves at Tidewater. Enjoy spacious living with excellent amenities in a prime Norfolk location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "page_item_url": "norfolk-apartments-near-norfolk-christian-schools-957",
      "search_query": "Norfolk apartments near Norfolk Christian Schools",
      "category": "School",
      "h1_title": "Norfolk Apartments Near Christian Schools",
      "h2_subtitle": "Explore Norfolk apartments located near Norfolk Christian Schools. Reserves at Tidewater offers a community perfect for families and students.",
      "page_copy": "Searching for Norfolk apartments near Norfolk Christian Schools? Reserves at Tidewater offers the ideal location for families and students alike. Situated in the welcoming Glenwood Park neighborhood, our community features modern one- and two-bedroom apartments with stylish interiors, including upgraded kitchen options and private balconies.\n\nExperience the vibrant community life at Reserves at Tidewater with amenities catering to your leisure and lifestyle needs. Spend your time at our refreshing swimming pool, stay active in our fitness center, or enjoy sunny days at our dog park. Positioned conveniently near Norfolk Christian Schools, our apartments provide the perfect home base for balancing educational pursuits and relaxed living in Norfolk, VA.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with mature trees in front.",
        "public_id": "01a015db-5ab7-736e-b281-cae542531f2e",
        "storage_key": "property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Norfolk Christian Schools",
      "seo_description": "Find Norfolk apartments near Christian Schools at Reserves at Tidewater. Enjoy family-friendly living with great amenities in a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "page_item_url": "tidewater-apartments-near-tidewater-community-college-norfolk-731",
      "search_query": "Tidewater apartments near Tidewater Community College Norfolk Campus",
      "category": "School",
      "h1_title": "Tidewater Apartments Near TCC Norfolk",
      "h2_subtitle": "Discover Tidewater apartments near Tidewater Community College Norfolk Campus. Ideal for students and professionals seeking convenience and comfort.",
      "page_copy": "Explore Tidewater apartments near Tidewater Community College Norfolk Campus, and discover a blend of comfort and convenience at Reserves at Tidewater. Our community, nestled in Norfolk's Glenwood Park, offers spacious one- and two-bedroom floor plans tailored for both students and professionals seeking proximity to TCC.\n\nWith modern kitchens, private balconies, and a range of amenities like a fitness center and swimming pool, Reserves at Tidewater is designed for a vibrant, yet relaxed lifestyle. Its prime location ensures that you're just minutes away from classes and campus life, making it a great choice whether you're pursuing studies or working nearby. Visit us today to see why our community stands out in Norfolk.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with mature trees in front.",
        "public_id": "01a015db-5ab7-736e-b281-cae542531f2e",
        "storage_key": "property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Tidewater Community College Norfolk",
      "seo_description": "Find Tidewater apartments near TCC Norfolk Campus at Reserves at Tidewater. Enjoy a convenient, student-friendly community in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "page_item_url": "apartments-near-sentara-norfolk-general-hospital-24",
      "search_query": "apartments near Sentara Norfolk General Hospital Norfolk",
      "category": "Hospital",
      "h1_title": "Apartments Near Sentara Norfolk General",
      "h2_subtitle": "Find convenient apartments near Sentara Norfolk General Hospital. Reserves at Tidewater offers ideal living for healthcare professionals and families.",
      "page_copy": "Looking for apartments near Sentara Norfolk General Hospital in Norfolk? Reserves at Tidewater offers the perfect solution with our spacious one- and two-bedroom apartment options. Located in the peaceful Glenwood Park neighborhood, our community is ideal for healthcare professionals and families seeking a comfortable and convenient lifestyle.\n\nReserves at Tidewater features amenities such as a modern fitness center, a relaxing swimming pool, and a pet-friendly dog park. These amenities cater to both work and recreation needs, allowing you to unwind after a busy day at the hospital. Situated just a short commute from Sentara Norfolk General, our apartments are the perfect choice for those wanting to balance a busy professional life with a welcoming home environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with mature trees in front.",
        "public_id": "01a015db-5ab7-736e-b281-cae542531f2e",
        "storage_key": "property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Sentara Norfolk General Hospital",
      "seo_description": "Discover apartments near Sentara Norfolk General at Reserves at Tidewater. Enjoy a comfortable and convenient lifestyle close to work.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "page_item_url": "apartments-near-northside-park-norfolk-851",
      "search_query": "apartments near northside park norfolk",
      "category": "Park",
      "h1_title": "Apartments Near Northside Park Norfolk",
      "h2_subtitle": "Discover apartments near Northside Park in Norfolk. Reserves at Tidewater offers a blend of comfort and recreation.",
      "page_copy": "Seeking apartments near Northside Park in Norfolk? Explore the inviting Reserves at Tidewater community where comfort meets recreation. Our spacious one- and two-bedroom floor plans are perfect for those who enjoy an active lifestyle in the scenic Glenwood Park neighborhood, located conveniently close to Northside Park.\n\nReserves at Tidewater goes beyond just a fantastic location. Our community features modern spaces with partial kitchen upgrades and private balconies. Residents can take advantage of amenities like our fitness center, swimming pool, and a dog park, making it an ideal spot for both leisure and relaxation. Whether you're an outdoor enthusiast or simply enjoy a peaceful, park-adjacent lifestyle, our apartments offer the best of Norfolk living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with mature trees in front.",
        "public_id": "01a015db-5ab7-736e-b281-cae542531f2e",
        "storage_key": "property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Northside Park in Norfolk",
      "seo_description": "Explore Reserves at Tidewater for apartments near Northside Park in Norfolk. Enjoy great amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "page_item_url": "reserves-tidewater-close-to-ocean-view-beach-park-662",
      "search_query": "reserves at tidewater close to ocean view beach park",
      "category": "Park",
      "h1_title": "Reserves at Tidewater Near Ocean View Beach",
      "h2_subtitle": "Experience Reserves at Tidewater close to Ocean View Beach Park. Perfect for seaside living, blending convenience and relaxation.",
      "page_copy": "Discover the charm of seaside living at Reserves at Tidewater, located close to the serene Ocean View Beach Park in Norfolk. Perfectly positioned for those who cherish the coast, our community offers the best blend of convenient living and natural beauty.\n\nReserves at Tidewater features spacious one- and two-bedroom apartments equipped with private balconies and partially upgraded kitchens. Whether you're lounging by our swimming pool or taking advantage of the nearby beach, you'll find plenty of opportunities to relax and rejuvenate. Enjoy a pet-friendly environment with a dog park, modern fitness center, and more—all just a short drive from the stunning Ocean View Beach Park. Experience the ultimate in Norfolk coastal living today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with mature trees in front.",
        "public_id": "01a015db-5ab7-736e-b281-cae542531f2e",
        "storage_key": "property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Live Near Ocean View Beach at Reserves",
      "seo_description": "Enjoy seaside living at Reserves at Tidewater, close to Ocean View Beach Park with great amenities and convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "page_item_url": "apartments-near-norfolk-botanical-garden-597",
      "search_query": "apartments near norfolk botanical garden va",
      "category": "Park",
      "h1_title": "Apartments Near Norfolk Botanical Garden",
      "h2_subtitle": "Explore living in apartments near Norfolk Botanical Garden, VA. Reserves at Tidewater offers tranquility and modern conveniences.",
      "page_copy": "Looking for serene living options near Norfolk Botanical Garden? Reserves at Tidewater provides the perfect retreat with its spacious one- and two-bedroom apartments, situated in the peaceful Glenwood Park neighborhood of Norfolk. Just a short drive away from the breathtaking landscapes of Norfolk Botanical Garden, our community is ideal for nature lovers and garden enthusiasts.\n\nEnjoy the tranquility of living close to nature while indulging in modern comforts. Our community features amenities such as a fully-equipped fitness center, a refreshing swimming pool, and a dog park for your furry friends. Each apartment offers private balconies and partially upgraded kitchens, ensuring a blend of luxury and practicality. Discover a lifestyle that balances the beauty of nature with the convenience of modern living at Reserves at Tidewater.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with mature trees in front.",
        "public_id": "01a015db-5ab7-736e-b281-cae542531f2e",
        "storage_key": "property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Norfolk Botanical Garden, VA",
      "seo_description": "Find tranquility at Reserves at Tidewater, close to Norfolk Botanical Garden. Perfect blend of natural beauty and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "page_item_url": "plum-point-park-nearby-apartments-norfolk-351",
      "search_query": "plum point park nearby apartments norfolk city",
      "category": "Park",
      "h1_title": "Plum Point Park Nearby Apartments",
      "h2_subtitle": "Discover apartments near Plum Point Park in Norfolk City. Reserves at Tidewater offers comfort and urban convenience in a vibrant setting.",
      "page_copy": "Searching for apartments close to Plum Point Park in Norfolk City? Look no further than Reserves at Tidewater, offering the perfect combination of comfort and convenience near this popular waterfront destination. Our community is ideal for anyone looking to enjoy city living while still being minutes from nature and outdoor activities.\n\nReserves at Tidewater provides residents with spacious one- and two-bedroom units featuring private balconies and partially upgraded kitchens. Experience the lifestyle you deserve with a variety of on-site amenities, including a swimming pool, a fitness center, and a dog park for your furry companions. Enjoy easy access to Plum Point Park, offering scenic views and walking trails, making it an ideal spot to relax and unwind after a busy day. Make the vibrant blend of urban living and natural beauty your own at Reserves at Tidewater today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with mature trees in front.",
        "public_id": "01a015db-5ab7-736e-b281-cae542531f2e",
        "storage_key": "property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Plum Point Park, Norfolk City",
      "seo_description": "Reserves at Tidewater offers convenient living near Plum Point Park in Norfolk City. Enjoy urban amenities and nearby park access.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "page_item_url": "apartments-next-to-town-point-park-23505-221",
      "search_query": "apartments next to town point park 23505",
      "category": "Park",
      "h1_title": "Apartments Next to Town Point Park",
      "h2_subtitle": "Find your home in apartments next to Town Point Park, 23505. Reserves at Tidewater offers premium living in a vibrant and accessible location.",
      "page_copy": "Looking for premium apartments next to Town Point Park in Norfolk's 23505 area? Reserves at Tidewater offers a dynamic home base with the perfect mix of modern living and easy access to Norfolk's popular waterfront park. \n\nAt Reserves at Tidewater, choose from spacious one- and two-bedroom floor plans, each featuring private balconies and contemporary kitchen designs. Delight in a host of amenities including a fitness center, dog park, and swimming pool, all designed to enhance your lifestyle. With Town Point Park just minutes away, enjoy the convenience of nearby festivals, concerts, and scenic river views. Discover a community where luxury meets leisure at Reserves at Tidewater.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with mature trees in front.",
        "public_id": "01a015db-5ab7-736e-b281-cae542531f2e",
        "storage_key": "property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Next to Town Point Park, 23505",
      "seo_description": "Live at Reserves at Tidewater, next to Norfolk's Town Point Park. Enjoy modern amenities, spacious homes, and park-side convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166342",
      "source": "custom",
      "page_item_url": "lafayette-park-neighboring-apartments-glenwood-944",
      "search_query": "lafayette park neighboring apartments glenwood park",
      "category": "Park",
      "h1_title": "Lafayette Park Neighboring Apartments",
      "h2_subtitle": "Explore apartments neighboring Lafayette Park in Glenwood Park. Reserves at Tidewater offers ideal living for park enthusiasts.",
      "page_copy": "Seeking an apartment next to Lafayette Park in the Glenwood Park area? Look no further than the Reserves at Tidewater. Our vibrant community provides the perfect setting for those who love the serenity of nature alongside modern conveniences.\n\nReserves at Tidewater offers spacious one- and two-bedroom units with private balconies, ensuring your living space meets all your needs. Enjoy on-site amenities like a fitness center, swimming pool, and a dog park, all while living just minutes from the lush landscapes of Lafayette Park. Embrace a community that provides comfort and easy access to nature at Reserves at Tidewater.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with mature trees in front.",
        "public_id": "01a015db-5ab7-736e-b281-cae542531f2e",
        "storage_key": "property/6767906449166342/01a015db-5ab7-736e-b281-cae542531f2e.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Lafayette Park, Glenwood Park",
      "seo_description": "Discover Reserves at Tidewater, neighboring Lafayette Park in Glenwood Park. Modern living with easy park access.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5079"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9976280181"
    },
    {
      "ID": "custom_fee_guide",
      "type": "BOOLEAN",
      "value": "true"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4973427"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KVQRFN8K"
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://reservesattidewater.fatwin.com/api/websites/resources/1?x=Ty9MODVteUNJVnFiQm1xT2JSK0ZGSnVBSzliVW5IcDJRUEdjTWo2TXYyemMyTlZrMnM5OEE0aWNwSllLQmhHMUc1K1BIZlpqNXRWZWdFaGdmNGE3aUE9PQ2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Belmont"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "54896221110"
    },
    {
      "ID": "custom_engrain_sitemap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/8epm5y3kw6d"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "95495998-43e6-11ef-8602-5753b3a9ab4c"
    },
    {
      "ID": "custom_eliseai_tour_scheduler",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95495998-43e6-11ef-8602-5753b3a9ab4c/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bbc32e5-b155-40a7-886b-b483419a5646"
    },
    {
      "ID": "custom_eliseai_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95495998-43e6-11ef-8602-5753b3a9ab4c/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImRWeDFkZGpHNndhWWhQZFJXVjlxRGc9PSIsInZhbHVlIjoidm9xdHV5YUtCa2RWenRzVEdIS2R1QT09IiwibWFjIjoiMDM2MmQ2M2Q5NjNiNzBkYWU0YWRmYWRkODgxMzYxNzRhNGUyZTdkZWM5N2UxNWI0ZmE4NWUwYWM2MjNhZTA0ZiJ9"
    },
    {
      "ID": "custom_loft_resident_download_apple",
      "type": "STRING",
      "value": "https://apps.apple.com/us/app/loft-living/id333244247"
    },
    {
      "ID": "custom_loft_resident_download_google",
      "type": "STRING",
      "value": "https://play.google.com/store/apps/details?id=com.activebuilding.residents"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "5079",
  "custom_repli_id": "9976280181",
  "custom_fee_guide": "true",
  "custom_realpage_id": "4973427",
  "custom_google_gtm_id": "GTM-KVQRFN8K",
  "custom_perq_script_url": "https://reservesattidewater.fatwin.com/api/websites/resources/1?x=Ty9MODVteUNJVnFiQm1xT2JSK0ZGSnVBSzliVW5IcDJRUEdjTWo2TXYyemMyTlZrMnM5OEE0aWNwSllLQmhHMUc1K1BIZlpqNXRWZWdFaGdmNGE3aUE9PQ2",
  "custom_vibesites_theme": "Belmont",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "54896221110",
  "custom_engrain_sitemap_url": "https://sightmap.com/embed/8epm5y3kw6d",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "95495998-43e6-11ef-8602-5753b3a9ab4c",
  "custom_eliseai_tour_scheduler": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95495998-43e6-11ef-8602-5753b3a9ab4c/tour?hideScrollBars=true",
  "custom_eliseai_organization_id": "4bbc32e5-b155-40a7-886b-b483419a5646",
  "custom_eliseai_tour_button_popup": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95495998-43e6-11ef-8602-5753b3a9ab4c/tour?hideScrollBars=true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImRWeDFkZGpHNndhWWhQZFJXVjlxRGc9PSIsInZhbHVlIjoidm9xdHV5YUtCa2RWenRzVEdIS2R1QT09IiwibWFjIjoiMDM2MmQ2M2Q5NjNiNzBkYWU0YWRmYWRkODgxMzYxNzRhNGUyZTdkZWM5N2UxNWI0ZmE4NWUwYWM2MjNhZTA0ZiJ9",
  "custom_loft_resident_download_apple": "https://apps.apple.com/us/app/loft-living/id333244247",
  "custom_loft_resident_download_google": "https://play.google.com/store/apps/details?id=com.activebuilding.residents",
  "custom_audioeye_site_id": "d3b9ba77-e084-4078-a9e6-732a7e13b260",
  "custom_audioeye_site_hash": "9d5ede627afd2e5323ae6e873798685e"
};

export const generatedAt = '2026-10-22T20:05:48.650Z';
